function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        catch: function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t4, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t4, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: _regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}
function _regeneratorAsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine2(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2(e, r, n, t);
}
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n2 = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n2 >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n2++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var Fe = Object.defineProperty;
var Oe = function Oe(s, i, e) {
  return i in s ? Fe(s, i, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : s[i] = e;
};
var p = function p(s, i, e) {
  return Oe(s, _typeof(i) != "symbol" ? i + "" : i, e);
};
import { Plugin as w, Command as v } from "../../../../../@ckeditor_ckeditor5-core@45.1.0/node_modules/@ckeditor/ckeditor5-core/dist/index.js";
import { Delete as Re } from "../../../../../@ckeditor_ckeditor5-typing@45.1.0/node_modules/@ckeditor/ckeditor5-typing/dist/index.js";
import { Enter as Me } from "../../../../../@ckeditor_ckeditor5-enter@45.1.0/node_modules/@ckeditor/ckeditor5-enter/dist/index.js";
import { CKEditorError as De, getCode as Ue, toArray as L, first as U, parseKeystroke as $e, getLocalizedArrowKeyCodeDirection as Ke, uid as We, FocusTracker as te, KeystrokeHandler as ie, global as je } from "../../../../../@ckeditor_ckeditor5-utils@45.1.0/node_modules/@ckeditor/ckeditor5-utils/dist/index.js";
import { ClipboardPipeline as qe } from "../../../../../@ckeditor_ckeditor5-clipboard@45.1.0/node_modules/@ckeditor/ckeditor5-clipboard/dist/index.js";
import { createDropdown as He, SplitButtonView as Ye, MenuBarMenuView as ze, ButtonView as Z, MenuBarMenuListItemButtonView as Ge, focusChildOnDropdownOpen as Ze, View as se, ViewCollection as Je, FocusCycler as Qe, addKeyboardHandlingForGrid as Xe, CollapsibleView as et, LabeledFieldView as tt, createLabeledInputNumber as it, SwitchButtonView as st } from "../../../../../@ckeditor_ckeditor5-ui@45.1.0/node_modules/@ckeditor/ckeditor5-ui/dist/index.js";
import { IconListStyleDisc as nt, IconListStyleCircle as rt, IconListStyleSquare as ot, IconListStyleDecimal as lt, IconListStyleDecimalLeadingZero as ct, IconListStyleLowerRoman as at, IconListStyleUpperRoman as ut, IconListStyleLowerLatin as dt, IconListStyleUpperLatin as ft, IconBulletedList as J, IconNumberedList as Q, IconTodoList as mt } from "../../../../../@ckeditor_ckeditor5-icons@45.1.0/node_modules/@ckeditor/ckeditor5-icons/dist/index.js";
import { DomEventObserver as pt, Matcher as ye } from "../../../../../@ckeditor_ckeditor5-engine@45.1.0/node_modules/@ckeditor/ckeditor5-engine/dist/index.js"; /**
                                                                                                                                                                * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                                                                * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                                                                */
var y = /*#__PURE__*/function () {
  function y(i, e) {
    _classCallCheck(this, y);
    p(this, "_startElement");
    p(this, "_referenceIndent");
    p(this, "_isForward");
    p(this, "_includeSelf");
    p(this, "_sameAttributes");
    p(this, "_sameIndent");
    p(this, "_lowerIndent");
    p(this, "_higherIndent");
    this._startElement = i, this._referenceIndent = i.getAttribute("listIndent"), this._isForward = e.direction == "forward", this._includeSelf = !!e.includeSelf, this._sameAttributes = L(e.sameAttributes || []), this._sameIndent = !!e.sameIndent, this._lowerIndent = !!e.lowerIndent, this._higherIndent = !!e.higherIndent;
  }
  return _createClass(y, [{
    key: Symbol.iterator,
    value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
      var _this = this;
      var i, _iterator, _step, _loop, _ret;
      return _regeneratorRuntime().wrap(function value$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            i = [];
            _iterator = _createForOfIteratorHelper(new N(this._getStartNode(), this._isForward ? "forward" : "backward"));
            _context2.prev = 2;
            _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              var _ref, e, t;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _ref = _step.value;
                    e = _ref.node;
                    t = e.getAttribute("listIndent");
                    if (!(t < _this._referenceIndent)) {
                      _context.next = 9;
                      break;
                    }
                    if (_this._lowerIndent) {
                      _context.next = 6;
                      break;
                    }
                    return _context.abrupt("return", 0);
                  case 6:
                    _this._referenceIndent = t;
                    _context.next = 27;
                    break;
                  case 9:
                    if (!(t > _this._referenceIndent)) {
                      _context.next = 17;
                      break;
                    }
                    if (_this._higherIndent) {
                      _context.next = 12;
                      break;
                    }
                    return _context.abrupt("return", 1);
                  case 12:
                    if (_this._isForward) {
                      _context.next = 15;
                      break;
                    }
                    i.push(e);
                    return _context.abrupt("return", 1);
                  case 15:
                    _context.next = 27;
                    break;
                  case 17:
                    if (_this._sameIndent) {
                      _context.next = 25;
                      break;
                    }
                    if (!_this._higherIndent) {
                      _context.next = 24;
                      break;
                    }
                    _context.t0 = i.length;
                    if (!_context.t0) {
                      _context.next = 23;
                      break;
                    }
                    return _context.delegateYield(i, "t1", 22);
                  case 22:
                    i.length = 0;
                  case 23:
                    return _context.abrupt("return", 0);
                  case 24:
                    return _context.abrupt("return", 1);
                  case 25:
                    if (!_this._sameAttributes.some(function (n) {
                      return e.getAttribute(n) !== _this._startElement.getAttribute(n);
                    })) {
                      _context.next = 27;
                      break;
                    }
                    return _context.abrupt("return", 0);
                  case 27:
                    _context.t2 = i.length;
                    if (!_context.t2) {
                      _context.next = 31;
                      break;
                    }
                    return _context.delegateYield(i, "t3", 30);
                  case 30:
                    i.length = 0;
                  case 31:
                    _context.next = 33;
                    return e;
                  case 33:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            });
            _iterator.s();
          case 5:
            if ((_step = _iterator.n()).done) {
              _context2.next = 14;
              break;
            }
            return _context2.delegateYield(_loop(), "t0", 7);
          case 7:
            _ret = _context2.t0;
            if (!(_ret === 0)) {
              _context2.next = 10;
              break;
            }
            return _context2.abrupt("break", 14);
          case 10:
            if (!(_ret === 1)) {
              _context2.next = 12;
              break;
            }
            return _context2.abrupt("continue", 12);
          case 12:
            _context2.next = 5;
            break;
          case 14:
            _context2.next = 19;
            break;
          case 16:
            _context2.prev = 16;
            _context2.t1 = _context2["catch"](2);
            _iterator.e(_context2.t1);
          case 19:
            _context2.prev = 19;
            _iterator.f();
            return _context2.finish(19);
          case 22:
          case "end":
            return _context2.stop();
        }
      }, value, this, [[2, 16, 19, 22]]);
    })
  }, {
    key: "_getStartNode",
    value: function _getStartNode() {
      return this._includeSelf ? this._startElement : this._isForward ? this._startElement.nextSibling : this._startElement.previousSibling;
    }
  }], [{
    key: "first",
    value: function first(i, e) {
      var n = new this(i, e)[Symbol.iterator]();
      return U(n);
    }
  }]);
}();
var N = /*#__PURE__*/function () {
  function N(i) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "forward";
    _classCallCheck(this, N);
    p(this, "_node");
    p(this, "_isForward");
    p(this, "_previousNodesByIndent", []);
    p(this, "_previous", null);
    p(this, "_previousNodeIndent", null);
    this._node = i, this._isForward = e === "forward";
  }
  return _createClass(N, [{
    key: Symbol.iterator,
    value: function value() {
      return this;
    }
  }, {
    key: "next",
    value: function next() {
      if (!h(this._node)) return {
        done: !0,
        value: void 0
      };
      var i = this._node.getAttribute("listIndent");
      var e = null;
      if (this._previous) {
        var n = this._previousNodeIndent;
        i > n ? this._previousNodesByIndent[n] = this._previous : i < n ? (e = this._previousNodesByIndent[i] || null, this._previousNodesByIndent.length = i) : e = this._previous;
      }
      var t = {
        node: this._node,
        previous: this._previous,
        previousNodeInList: e
      };
      return this._previous = this._node, this._previousNodeIndent = i, this._node = this._isForward ? this._node.nextSibling : this._node.previousSibling, {
        value: t,
        done: !1
      };
    }
  }]);
}();
var ht = /*#__PURE__*/function () {
  function ht(i) {
    _classCallCheck(this, ht);
    p(this, "_listHead");
    this._listHead = i;
  }
  return _createClass(ht, [{
    key: Symbol.iterator,
    value: function value() {
      return new N(this._listHead);
    }
  }]);
}();
var _ = /*#__PURE__*/function () {
  function _() {
    _classCallCheck(this, _);
  }
  return _createClass(_, null, [{
    key: "next",
    value: function next() {
      return We();
    }
  }]);
}();
function h(s) {
  return !!s && s.is("element") && s.hasAttribute("listItemId");
}
function C(s) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return [].concat(_toConsumableArray(T(s, _objectSpread(_objectSpread({}, i), {}, {
    direction: "backward"
  }))), _toConsumableArray(T(s, _objectSpread(_objectSpread({}, i), {}, {
    direction: "forward"
  }))));
}
function T(s) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var e = i.direction == "forward",
    t = Array.from(new y(s, _objectSpread(_objectSpread({}, i), {}, {
      includeSelf: e,
      sameIndent: !0,
      sameAttributes: "listItemId"
    })));
  return e ? t : t.reverse();
}
function gt(s) {
  return Array.from(new y(s, {
    direction: "forward",
    higherIndent: !0
  }));
}
function Ie(s, i) {
  var e = new y(s, _objectSpread({
      sameIndent: !0,
      sameAttributes: "listType"
    }, i)),
    t = new y(s, _objectSpread({
      sameIndent: !0,
      sameAttributes: "listType",
      includeSelf: !0,
      direction: "forward"
    }, i));
  return [].concat(_toConsumableArray(Array.from(e).reverse()), _toConsumableArray(t));
}
function k(s) {
  return !y.first(s, {
    sameIndent: !0,
    sameAttributes: "listItemId"
  });
}
function ne(s) {
  return !y.first(s, {
    direction: "forward",
    sameIndent: !0,
    sameAttributes: "listItemId"
  });
}
function F(s) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  s = L(s);
  var e = i.withNested !== !1,
    t = new Set();
  var _iterator2 = _createForOfIteratorHelper(s),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var n = _step2.value;
      var _iterator3 = _createForOfIteratorHelper(C(n, {
          higherIndent: e
        })),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var r = _step3.value;
          t.add(r);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return S(t);
}
function $(s) {
  s = L(s);
  var i = new Set();
  var _iterator4 = _createForOfIteratorHelper(s),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var e = _step4.value;
      var _iterator5 = _createForOfIteratorHelper(Ie(e)),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var t = _step5.value;
          i.add(t);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return S(i);
}
function X(s, i) {
  var e = T(s, {
      direction: "forward"
    }),
    t = _.next();
  var _iterator6 = _createForOfIteratorHelper(e),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var n = _step6.value;
      i.setAttribute("listItemId", t, n);
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  return e;
}
function q(s, i, e) {
  var t = {};
  var _iterator7 = _createForOfIteratorHelper(i.getAttributes()),
    _step7;
  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var _ref2 = _step7.value;
      var _ref3 = _slicedToArray(_ref2, 2);
      var r = _ref3[0];
      var o = _ref3[1];
      r.startsWith("list") && (t[r] = o);
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
  var n = T(s, {
    direction: "forward"
  });
  var _iterator8 = _createForOfIteratorHelper(n),
    _step8;
  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var _r = _step8.value;
      e.setAttributes(t, _r);
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
  return n;
}
function H(s, i) {
  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    e = _ref4.expand,
    _ref4$indentBy = _ref4.indentBy,
    t = _ref4$indentBy === void 0 ? 1 : _ref4$indentBy;
  s = L(s);
  var n = e ? F(s) : s;
  var _iterator9 = _createForOfIteratorHelper(n),
    _step9;
  try {
    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
      var r = _step9.value;
      var o = r.getAttribute("listIndent") + t;
      o < 0 ? K(r, i) : i.setAttribute("listIndent", o, r);
    }
  } catch (err) {
    _iterator9.e(err);
  } finally {
    _iterator9.f();
  }
  return n;
}
function bt(s, i) {
  s = L(s);
  var e = F(s),
    t = new Set(),
    n = Math.min.apply(Math, _toConsumableArray(e.map(function (o) {
      return o.getAttribute("listIndent");
    }))),
    r = new Map();
  var _iterator0 = _createForOfIteratorHelper(e),
    _step0;
  try {
    for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
      var o = _step0.value;
      r.set(o, y.first(o, {
        lowerIndent: !0
      }));
    }
  } catch (err) {
    _iterator0.e(err);
  } finally {
    _iterator0.f();
  }
  var _iterator1 = _createForOfIteratorHelper(e),
    _step1;
  try {
    for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
      var _o = _step1.value;
      if (t.has(_o)) continue;
      t.add(_o);
      var l = _o.getAttribute("listIndent") - 1;
      if (l < 0) {
        K(_o, i);
        continue;
      }
      if (_o.getAttribute("listIndent") == n) {
        var c = It(_o, r.get(_o), i);
        var _iterator10 = _createForOfIteratorHelper(c),
          _step10;
        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var a = _step10.value;
            t.add(a);
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
        if (c.length) continue;
      }
      i.setAttribute("listIndent", l, _o);
    }
  } catch (err) {
    _iterator1.e(err);
  } finally {
    _iterator1.f();
  }
  return S(t);
}
function K(s, i) {
  s = L(s);
  var _iterator11 = _createForOfIteratorHelper(s),
    _step11;
  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      var e = _step11.value;
      e.is("element", "listItem") && i.rename(e, "paragraph");
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }
  var _iterator12 = _createForOfIteratorHelper(s),
    _step12;
  try {
    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
      var _e2 = _step12.value;
      var _iterator13 = _createForOfIteratorHelper(_e2.getAttributeKeys()),
        _step13;
      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var t = _step13.value;
          t.startsWith("list") && i.removeAttribute(t, _e2);
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }
    }
  } catch (err) {
    _iterator12.e(err);
  } finally {
    _iterator12.f();
  }
  return s;
}
function B(s) {
  if (!s.length) return !1;
  var i = s[0].getAttribute("listItemId");
  return i ? !s.some(function (e) {
    return e.getAttribute("listItemId") != i;
  }) : !1;
}
function yt(s, i) {
  var e = [];
  var t = Number.POSITIVE_INFINITY;
  var _iterator14 = _createForOfIteratorHelper(new N(s.nextSibling)),
    _step14;
  try {
    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
      var _ref5 = _step14.value;
      var n = _ref5.node;
      var r = n.getAttribute("listIndent");
      if (r == 0) break;
      r < t && (t = r);
      var o = r - t;
      i.setAttribute("listIndent", o, n), e.push(n);
    }
  } catch (err) {
    _iterator14.e(err);
  } finally {
    _iterator14.f();
  }
  return e;
}
function S(s) {
  return Array.from(s).filter(function (i) {
    return i.root.rootName !== "$graveyard";
  }).sort(function (i, e) {
    return i.index - e.index;
  });
}
function P(s) {
  var i = s.document.selection.getSelectedElement();
  return i && s.schema.isObject(i) && s.schema.isBlock(i) ? i : null;
}
function W(s, i) {
  return i.checkChild(s.parent, "listItem") && i.checkChild(s, "$text") && !i.isObject(s);
}
function D(s) {
  return s == "numbered" || s == "customNumbered";
}
function It(s, i, e) {
  return T(i, {
    direction: "forward"
  }).pop().index > s.index ? q(s, i, e) : [];
}
var re = /*#__PURE__*/function (_v) {
  function re(e, t) {
    var _this2;
    _classCallCheck(this, re);
    _this2 = _callSuper(this, re, [e]);
    p(_this2, "_direction");
    _this2._direction = t;
    return _this2;
  }
  _inherits(re, _v);
  return _createClass(re, [{
    key: "refresh",
    value: function refresh() {
      this.isEnabled = this._checkEnabled();
    }
  }, {
    key: "execute",
    value: function execute() {
      var _this3 = this;
      var e = this.editor.model,
        t = oe(e.document.selection);
      e.change(function (n) {
        var r = [];
        B(t) && !k(t[0]) ? (_this3._direction == "forward" && r.push.apply(r, _toConsumableArray(H(t, n))), r.push.apply(r, _toConsumableArray(X(t[0], n)))) : _this3._direction == "forward" ? r.push.apply(r, _toConsumableArray(H(t, n, {
          expand: !0
        }))) : r.push.apply(r, _toConsumableArray(bt(t, n)));
        for (var _i = 0, _r2 = r; _i < _r2.length; _i++) {
          var o = _r2[_i];
          if (!o.hasAttribute("listType")) continue;
          var l = y.first(o, {
            sameIndent: !0
          });
          l && n.setAttribute("listType", l.getAttribute("listType"), o);
        }
        _this3._fireAfterExecute(r);
      });
    }
  }, {
    key: "_fireAfterExecute",
    value: function _fireAfterExecute(e) {
      this.fire("afterExecute", S(new Set(e)));
    }
  }, {
    key: "_checkEnabled",
    value: function _checkEnabled() {
      var e = oe(this.editor.model.document.selection),
        t = e[0];
      if (!t) return !1;
      if (this._direction == "backward" || B(e) && !k(e[0])) return !0;
      e = F(e), t = e[0];
      var n = y.first(t, {
        sameIndent: !0
      });
      return n ? n.getAttribute("listType") == t.getAttribute("listType") : !1;
    }
  }]);
}(v);
function oe(s) {
  var i = Array.from(s.getSelectedBlocks()),
    e = i.findIndex(function (t) {
      return !h(t);
    });
  return e != -1 && (i.length = e), i;
}
var E = /*#__PURE__*/function (_v2) {
  function E(e, t) {
    var _this4;
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, E);
    _this4 = _callSuper(this, E, [e]);
    p(_this4, "type");
    p(_this4, "_listWalkerOptions");
    _this4.type = t, _this4._listWalkerOptions = n.multiLevel ? {
      higherIndent: !0,
      lowerIndent: !0,
      sameAttributes: []
    } : void 0;
    return _this4;
  }
  _inherits(E, _v2);
  return _createClass(E, [{
    key: "refresh",
    value: function refresh() {
      this.value = this._getValue(), this.isEnabled = this._checkEnabled();
    }
  }, {
    key: "execute",
    value: function execute() {
      var _this5 = this;
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t = this.editor.model,
        n = t.document,
        r = P(t),
        o = Array.from(n.selection.getSelectedBlocks()).filter(function (c) {
          return t.schema.checkAttribute(c, "listType") || W(c, t.schema);
        }),
        l = e.forceValue !== void 0 ? !e.forceValue : this.value;
      t.change(function (c) {
        if (l) {
          var a = o[o.length - 1],
            u = T(a, {
              direction: "forward"
            }),
            d = [];
          u.length > 1 && d.push.apply(d, _toConsumableArray(X(u[1], c))), d.push.apply(d, _toConsumableArray(K(o, c))), d.push.apply(d, _toConsumableArray(yt(a, c))), _this5._fireAfterExecute(d);
        } else if ((r || n.selection.isCollapsed) && h(o[0])) {
          var _a = Ie(r || o[0], _this5._listWalkerOptions);
          var _iterator15 = _createForOfIteratorHelper(_a),
            _step15;
          try {
            for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
              var _u = _step15.value;
              c.setAttributes(_objectSpread(_objectSpread({}, e.additionalAttributes), {}, {
                listType: _this5.type
              }), _u);
            }
          } catch (err) {
            _iterator15.e(err);
          } finally {
            _iterator15.f();
          }
          _this5._fireAfterExecute(_a);
        } else {
          var _a2 = [];
          var _iterator16 = _createForOfIteratorHelper(o),
            _step16;
          try {
            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              var _u2 = _step16.value;
              if (!_u2.hasAttribute("listType")) !_u2.is("element", "listItem") && W(_u2, t.schema) && c.rename(_u2, "listItem"), c.setAttributes(_objectSpread(_objectSpread({}, e.additionalAttributes), {}, {
                listIndent: 0,
                listItemId: _.next(),
                listType: _this5.type
              }), _u2), _a2.push(_u2);else {
                var _iterator17 = _createForOfIteratorHelper(F(_u2, {
                    withNested: !1
                  })),
                  _step17;
                try {
                  for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                    var _d = _step17.value;
                    _d.getAttribute("listType") != _this5.type && (c.setAttributes(_objectSpread(_objectSpread({}, e.additionalAttributes), {}, {
                      listType: _this5.type
                    }), _d), _a2.push(_d));
                  }
                } catch (err) {
                  _iterator17.e(err);
                } finally {
                  _iterator17.f();
                }
              }
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }
          _this5._fireAfterExecute(_a2);
        }
      });
    }
  }, {
    key: "_fireAfterExecute",
    value: function _fireAfterExecute(e) {
      this.fire("afterExecute", S(new Set(e)));
    }
  }, {
    key: "_getValue",
    value: function _getValue() {
      var e = this.editor.model.document.selection,
        t = Array.from(e.getSelectedBlocks());
      if (!t.length) return !1;
      for (var _i2 = 0, _t2 = t; _i2 < _t2.length; _i2++) {
        var n = _t2[_i2];
        if (n.getAttribute("listType") != this.type) return !1;
      }
      return !0;
    }
  }, {
    key: "_checkEnabled",
    value: function _checkEnabled() {
      var e = this.editor.model,
        t = e.schema,
        n = e.document.selection,
        r = Array.from(n.getSelectedBlocks());
      if (!r.length) return !1;
      if (this.value) return !0;
      for (var _i3 = 0, _r3 = r; _i3 < _r3.length; _i3++) {
        var o = _r3[_i3];
        if (t.checkAttribute(o, "listType") || W(o, t)) return !0;
      }
      return !1;
    }
  }]);
}(v);
var le = /*#__PURE__*/function (_v3) {
  function le(e, t) {
    var _this6;
    _classCallCheck(this, le);
    _this6 = _callSuper(this, le, [e]);
    p(_this6, "_direction");
    _this6._direction = t;
    return _this6;
  }
  _inherits(le, _v3);
  return _createClass(le, [{
    key: "refresh",
    value: function refresh() {
      this.isEnabled = this._checkEnabled();
    }
  }, {
    key: "execute",
    value: function execute() {
      var _this7 = this;
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref6$shouldMergeOnBl = _ref6.shouldMergeOnBlocksContentLevel,
        e = _ref6$shouldMergeOnBl === void 0 ? !1 : _ref6$shouldMergeOnBl;
      var t = this.editor.model,
        n = t.document.selection,
        r = [];
      t.change(function (o) {
        var _this7$_getMergeSubje = _this7._getMergeSubjectElements(n, e),
          l = _this7$_getMergeSubje.firstElement,
          c = _this7$_getMergeSubje.lastElement,
          a = l.getAttribute("listIndent") || 0,
          u = c.getAttribute("listIndent"),
          d = c.getAttribute("listItemId");
        if (a != u) {
          var f = gt(c);
          r.push.apply(r, _toConsumableArray(H([c].concat(_toConsumableArray(f)), o, {
            indentBy: a - u,
            expand: a < u
          })));
        }
        if (e) {
          var _f = n;
          n.isCollapsed && (_f = o.createSelection(o.createRange(o.createPositionAt(l, "end"), o.createPositionAt(c, 0)))), t.deleteContent(_f, {
            doNotResetEntireContent: n.isCollapsed
          });
          var m = _f.getLastPosition().parent,
            g = m.nextSibling;
          r.push(m), g && g !== c && g.getAttribute("listItemId") == d && r.push.apply(r, _toConsumableArray(q(g, m, o)));
        } else r.push.apply(r, _toConsumableArray(q(c, l, o)));
        _this7._fireAfterExecute(r);
      });
    }
  }, {
    key: "_fireAfterExecute",
    value: function _fireAfterExecute(e) {
      this.fire("afterExecute", S(new Set(e)));
    }
  }, {
    key: "_checkEnabled",
    value: function _checkEnabled() {
      var e = this.editor.model,
        t = e.document.selection,
        n = P(e);
      if (t.isCollapsed || n) {
        var r = n || t.getFirstPosition().parent;
        if (!h(r)) return !1;
        var o = this._direction == "backward" ? r.previousSibling : r.nextSibling;
        if (!o || B([r, o])) return !1;
      } else {
        var _r4 = t.getLastPosition(),
          _o2 = t.getFirstPosition();
        if (_r4.parent === _o2.parent || !h(_r4.parent)) return !1;
      }
      return !0;
    }
  }, {
    key: "_getMergeSubjectElements",
    value: function _getMergeSubjectElements(e, t) {
      var n = this.editor.model,
        r = P(n);
      var o, l;
      if (e.isCollapsed || r) {
        var c = r || e.getFirstPosition().parent,
          a = k(c);
        this._direction == "backward" ? (l = c, a && !t ? o = y.first(c, {
          sameIndent: !0,
          lowerIndent: !0
        }) : o = c.previousSibling) : (o = c, l = c.nextSibling);
      } else o = e.getFirstPosition().parent, l = e.getLastPosition().parent;
      return {
        firstElement: o,
        lastElement: l
      };
    }
  }]);
}(v);
var ce = /*#__PURE__*/function (_v4) {
  function ce(e, t) {
    var _this8;
    _classCallCheck(this, ce);
    _this8 = _callSuper(this, ce, [e]);
    p(_this8, "_direction");
    _this8._direction = t;
    return _this8;
  }
  _inherits(ce, _v4);
  return _createClass(ce, [{
    key: "refresh",
    value: function refresh() {
      this.isEnabled = this._checkEnabled();
    }
  }, {
    key: "execute",
    value: function execute() {
      var _this9 = this;
      this.editor.model.change(function (t) {
        var n = X(_this9._getStartBlock(), t);
        _this9._fireAfterExecute(n);
      });
    }
  }, {
    key: "_fireAfterExecute",
    value: function _fireAfterExecute(e) {
      this.fire("afterExecute", S(new Set(e)));
    }
  }, {
    key: "_checkEnabled",
    value: function _checkEnabled() {
      var e = this.editor.model.document.selection,
        t = this._getStartBlock();
      return e.isCollapsed && h(t) && !k(t);
    }
  }, {
    key: "_getStartBlock",
    value: function _getStartBlock() {
      var t = this.editor.model.document.selection.getFirstPosition().parent;
      return this._direction == "before" ? t : t.nextSibling;
    }
  }]);
}(v);
var wt = /*#__PURE__*/function (_w) {
  function wt() {
    _classCallCheck(this, wt);
    return _callSuper(this, wt, arguments);
  }
  _inherits(wt, _w);
  return _createClass(wt, [{
    key: "expandListBlocksToCompleteList",
    value: function expandListBlocksToCompleteList(i) {
      return $(i);
    }
  }, {
    key: "isFirstBlockOfListItem",
    value: function isFirstBlockOfListItem(i) {
      return k(i);
    }
  }, {
    key: "isListItemBlock",
    value: function isListItemBlock(i) {
      return h(i);
    }
  }, {
    key: "expandListBlocksToCompleteItems",
    value: function expandListBlocksToCompleteItems(i) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return F(i, e);
    }
  }, {
    key: "isNumberedListType",
    value: function isNumberedListType(i) {
      return D(i);
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "ListUtils";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(w);
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function At(s) {
  return s.is("element", "ol") || s.is("element", "ul");
}
function Y(s) {
  return s.is("element", "li");
}
function kt(s) {
  var i = 0,
    e = s.parent;
  for (; e;) {
    if (Y(e)) i++;else {
      var t = e.previousSibling;
      t && Y(t) && i++;
    }
    e = e.parent;
  }
  return i;
}
function Lt(s, i, e) {
  var t = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Ae(e, i);
  return s.createAttributeElement(we(e), null, {
    priority: 2 * i / 100 - 100,
    id: t
  });
}
function Tt(s, i, e) {
  return s.createAttributeElement("li", null, {
    priority: (2 * i + 1) / 100 - 100,
    id: e
  });
}
function we(s) {
  return s == "numbered" || s == "customNumbered" ? "ol" : "ul";
}
function Ae(s, i) {
  return "list-".concat(s, "-").concat(i);
}
function I(s, i, e) {
  var t = s.nodeBefore;
  if (h(t)) {
    var n = t;
    var _iterator18 = _createForOfIteratorHelper(new N(n, "backward")),
      _step18;
    try {
      for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
        var _ref7 = _step18.value;
        var r = _ref7.node;
        if (n = r, e.has(n) || (e.add(n), i.has(t))) return;
      }
    } catch (err) {
      _iterator18.e(err);
    } finally {
      _iterator18.f();
    }
    i.add(n);
  } else {
    var _n = s.nodeAfter;
    h(_n) && i.add(_n);
  }
}
function vt(s, i) {
  var e = 0,
    t = -1,
    n = null,
    r = !1;
  var _iterator19 = _createForOfIteratorHelper(s),
    _step19;
  try {
    for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
      var _ref8 = _step19.value;
      var o = _ref8.node;
      var l = o.getAttribute("listIndent");
      if (l > e) {
        var c = void 0;
        n === null ? (n = l - e, c = e) : (n > l && (n = l), c = l - n), c > t + 1 && (c = t + 1), i.setAttribute("listIndent", c, o), r = !0, t = c;
      } else n = null, e = l + 1, t = l;
    }
  } catch (err) {
    _iterator19.e(err);
  } finally {
    _iterator19.f();
  }
  return r;
}
function St(s, i, e) {
  var t = new Set();
  var n = !1;
  var _iterator20 = _createForOfIteratorHelper(s),
    _step20;
  try {
    for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
      var _ref9 = _step20.value;
      var r = _ref9.node;
      if (t.has(r)) continue;
      var o = r.getAttribute("listType"),
        l = r.getAttribute("listItemId");
      if (i.has(l) && (l = _.next()), i.add(l), r.is("element", "listItem")) {
        r.getAttribute("listItemId") != l && (e.setAttribute("listItemId", l, r), n = !0);
        continue;
      }
      var _iterator21 = _createForOfIteratorHelper(T(r, {
          direction: "forward"
        })),
        _step21;
      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var c = _step21.value;
          t.add(c), c.getAttribute("listType") != o && (l = _.next(), o = c.getAttribute("listType")), c.getAttribute("listItemId") != l && (e.setAttribute("listItemId", l, c), n = !0);
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
    }
  } catch (err) {
    _iterator20.e(err);
  } finally {
    _iterator20.f();
  }
  return n;
}
function _t() {
  return function (s, i, e) {
    var t = e.writer,
      n = e.schema;
    if (!i.modelRange) return;
    var r = Array.from(i.modelRange.getItems({
      shallow: !0
    })).filter(function (d) {
      return n.checkAttribute(d, "listItemId");
    });
    if (!r.length) return;
    var o = _.next(),
      l = kt(i.viewItem);
    var c = i.viewItem.parent && i.viewItem.parent.is("element", "ol") ? "numbered" : "bulleted";
    var a = r[0].getAttribute("listType");
    a && (c = a);
    var u = {
      listItemId: o,
      listIndent: l,
      listType: c
    };
    var _iterator22 = _createForOfIteratorHelper(r),
      _step22;
    try {
      for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
        var d = _step22.value;
        d.hasAttribute("listItemId") || t.setAttributes(u, d);
      }
    } catch (err) {
      _iterator22.e(err);
    } finally {
      _iterator22.f();
    }
    r.length > 1 && r[1].getAttribute("listItemId") != u.listItemId && e.keepEmptyElement(r[0]);
  };
}
function Ct(s, i, e, t) {
  return function () {
    var l = s.document.differ.getChanges(),
      c = [],
      a = new Set(),
      u = new Set(),
      d = new Set();
    var _iterator23 = _createForOfIteratorHelper(l),
      _step23;
    try {
      for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
        var f = _step23.value;
        if (f.type == "insert" && f.name != "$text") I(f.position, a, d), f.attributes.has("listItemId") ? u.add(f.position.nodeAfter) : I(f.position.getShiftedBy(f.length), a, d);else if (f.type == "remove" && f.attributes.has("listItemId")) I(f.position, a, d);else if (f.type == "attribute") {
          var m = f.range.start.nodeAfter;
          e.includes(f.attributeKey) ? (I(f.range.start, a, d), f.attributeNewValue === null ? (I(f.range.start.getShiftedBy(1), a, d), r(m) && c.push(m)) : u.add(m)) : h(m) && r(m) && c.push(m);
        }
      }
    } catch (err) {
      _iterator23.e(err);
    } finally {
      _iterator23.f();
    }
    var _iterator24 = _createForOfIteratorHelper(a.values()),
      _step24;
    try {
      for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
        var _f2 = _step24.value;
        c.push.apply(c, _toConsumableArray(n(_f2, u)));
      }
    } catch (err) {
      _iterator24.e(err);
    } finally {
      _iterator24.f();
    }
    var _iterator25 = _createForOfIteratorHelper(new Set(c)),
      _step25;
    try {
      for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
        var _f3 = _step25.value;
        i.reconvertItem(_f3);
      }
    } catch (err) {
      _iterator25.e(err);
    } finally {
      _iterator25.f();
    }
  };
  function n(l, c) {
    var a = [],
      u = new Set(),
      d = [];
    var _iterator26 = _createForOfIteratorHelper(new N(l)),
      _step26;
    try {
      for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
        var _ref0 = _step26.value;
        var f = _ref0.node;
        var m = _ref0.previous;
        if (u.has(f)) continue;
        var g = f.getAttribute("listIndent");
        m && g < m.getAttribute("listIndent") && (d.length = g + 1), d[g] = Object.fromEntries(Array.from(f.getAttributes()).filter(function (_ref1) {
          var _ref10 = _slicedToArray(_ref1, 1),
            b = _ref10[0];
          return e.includes(b);
        }));
        var A = T(f, {
          direction: "forward"
        });
        var _iterator27 = _createForOfIteratorHelper(A),
          _step27;
        try {
          for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
            var b = _step27.value;
            u.add(b), (r(b, A) || o(b, d, c)) && a.push(b);
          }
        } catch (err) {
          _iterator27.e(err);
        } finally {
          _iterator27.f();
        }
      }
    } catch (err) {
      _iterator26.e(err);
    } finally {
      _iterator26.f();
    }
    return a;
  }
  function r(l, c) {
    var a = i.mapper.toViewElement(l);
    if (!a) return !1;
    if (t.fire("checkElement", {
      modelElement: l,
      viewElement: a
    })) return !0;
    if (!l.is("element", "paragraph") && !l.is("element", "listItem")) return !1;
    var d = Le(l, e, c);
    return d && a.is("element", "p") ? !0 : !!(!d && a.is("element", "span"));
  }
  function o(l, c, a) {
    if (a.has(l)) return !1;
    var u = i.mapper.toViewElement(l);
    var d = c.length - 1;
    for (var f = u.parent; !f.is("editableElement"); f = f.parent) {
      var m = Y(f),
        g = At(f);
      if (!g && !m) continue;
      var A = "checkAttributes:".concat(m ? "item" : "list");
      if (t.fire(A, {
        viewElement: f,
        modelAttributes: c[d]
      })) break;
      if (g && (d--, d < 0)) return !1;
    }
    return !0;
  }
}
function ae(s, i, e) {
  var _ref11 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    t = _ref11.dataPipeline;
  var n = Ft(s);
  return function (r, o, l) {
    var c = l.writer,
      a = l.mapper,
      u = l.consumable,
      d = o.item;
    if (!s.includes(o.attributeKey) || !n(d, u)) return;
    var f = Et(d, a, e);
    ke(f, c, a), Vt(f, c);
    var m = Pt(d, f, i, c, {
      dataPipeline: t
    });
    Nt(d, m, i, c);
  };
}
function xt(s) {
  return function (i, e, t) {
    var n = t.writer,
      r = t.mapper,
      o = i.name.split(":")[1];
    if (!s.checkAttribute(o, "listItemId")) return;
    var l = r.toViewPosition(e.position),
      c = e.position.getShiftedBy(e.length),
      a = r.toViewPosition(c, {
        isPhantom: !0
      }),
      d = n.createRange(l, a).getTrimmed().end.nodeBefore; /* istanbul ignore next -- @preserve */
    d && ke(d, n, r);
  };
}
function ue(s) {
  var _ref12 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    i = _ref12.dataPipeline;
  return function (e, _ref13) {
    var t = _ref13.writer;
    if (!Le(e, s)) return null;
    if (!i) return t.createContainerElement("span", {
      class: "ck-list-bogus-paragraph"
    });
    var n = t.createContainerElement("p");
    return t.setCustomProperty("dataPipeline:transparentRendering", !0, n), n;
  };
}
function Et(s, i, e) {
  var t = e.createRangeOn(s);
  return i.toViewRange(t).getTrimmed().end.nodeBefore;
}
function Bt(s, i) {
  return function (e, t) {
    if (t.modelPosition.offset > 0) return;
    var n = t.modelPosition.parent;
    if (!h(n) || !s.some(function (a) {
      return a.scope == "itemMarker" && a.canInjectMarkerIntoElement && a.canInjectMarkerIntoElement(n);
    })) return;
    var r = t.mapper.toViewElement(n),
      o = i.createRangeIn(r),
      l = o.getWalker();
    var c = o.start;
    var _iterator28 = _createForOfIteratorHelper(l),
      _step28;
    try {
      for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
        var _ref14 = _step28.value;
        var a = _ref14.item;
        if (a.is("element") && t.mapper.toModelElement(a) || a.is("$textProxy")) break;
        a.is("element") && a.getCustomProperty("listItemMarker") && (c = i.createPositionAfter(a), l.skip(function (_ref15) {
          var u = _ref15.previousPosition;
          return !u.isEqual(c);
        }));
      }
    } catch (err) {
      _iterator28.e(err);
    } finally {
      _iterator28.f();
    }
    t.viewPosition = c;
  };
}
function ke(s, i, e) {
  for (; s.parent.is("attributeElement") && s.parent.getCustomProperty("listItemWrapper");) i.unwrap(i.createRangeOn(s), s.parent);
  var t = [];
  n(i.createPositionBefore(s).getWalker({
    direction: "backward"
  })), n(i.createRangeIn(s).getWalker());
  for (var _i4 = 0, _t3 = t; _i4 < _t3.length; _i4++) {
    var r = _t3[_i4];
    i.remove(r);
  }
  function n(r) {
    var _iterator29 = _createForOfIteratorHelper(r),
      _step29;
    try {
      for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
        var _ref16 = _step29.value;
        var o = _ref16.item;
        if (o.is("element") && e.toModelElement(o)) break;
        o.is("element") && o.getCustomProperty("listItemMarker") && t.push(o);
      }
    } catch (err) {
      _iterator29.e(err);
    } finally {
      _iterator29.f();
    }
  }
}
function Pt(s, i, e, t, _ref17) {
  var n = _ref17.dataPipeline;
  var r = t.createRangeOn(i);
  if (!k(s)) return r;
  var _iterator30 = _createForOfIteratorHelper(e),
    _step30;
  try {
    for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
      var o = _step30.value;
      if (o.scope != "itemMarker") continue;
      var l = o.createElement(t, s, {
        dataPipeline: n
      });
      if (!l || (t.setCustomProperty("listItemMarker", !0, l), o.canInjectMarkerIntoElement && o.canInjectMarkerIntoElement(s) ? t.insert(t.createPositionAt(i, 0), l) : (t.insert(r.start, l), r = t.createRange(t.createPositionBefore(l), t.createPositionAfter(i))), !o.createWrapperElement || !o.canWrapElement)) continue;
      var c = o.createWrapperElement(t, s, {
        dataPipeline: n
      });
      t.setCustomProperty("listItemWrapper", !0, c), o.canWrapElement(s) ? r = t.wrap(r, c) : (r = t.wrap(t.createRangeOn(l), c), r = t.createRange(r.start, t.createPositionAfter(i)));
    }
  } catch (err) {
    _iterator30.e(err);
  } finally {
    _iterator30.f();
  }
  return r;
}
function Vt(s, i) {
  var e = s.parent;
  for (; e.is("attributeElement") && ["ul", "ol", "li"].includes(e.name);) {
    var t = e.parent;
    i.unwrap(i.createRangeOn(s), e), e = t;
  }
}
function Nt(s, i, e, t) {
  if (!s.hasAttribute("listIndent")) return;
  var n = s.getAttribute("listIndent");
  var r = s;
  for (var o = n; o >= 0; o--) {
    var l = Tt(t, o, r.getAttribute("listItemId")),
      c = Lt(t, o, r.getAttribute("listType"));
    var _iterator31 = _createForOfIteratorHelper(e),
      _step31;
    try {
      for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
        var a = _step31.value;
        (a.scope == "list" || a.scope == "item") && r.hasAttribute(a.attributeName) && a.setAttributeOnDowncast(t, r.getAttribute(a.attributeName), a.scope == "list" ? c : l);
      }
    } catch (err) {
      _iterator31.e(err);
    } finally {
      _iterator31.f();
    }
    if (i = t.wrap(i, l), i = t.wrap(i, c), o == 0 || (r = y.first(r, {
      lowerIndent: !0
    }), !r)) break;
  }
}
function Ft(s) {
  return function (i, e) {
    var t = [];
    var _iterator32 = _createForOfIteratorHelper(s),
      _step32;
    try {
      for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
        var n = _step32.value;
        i.hasAttribute(n) && t.push("attribute:".concat(n));
      }
    } catch (err) {
      _iterator32.e(err);
    } finally {
      _iterator32.f();
    }
    return t.every(function (n) {
      return e.test(i, n) !== !1;
    }) ? (t.forEach(function (n) {
      return e.consume(i, n);
    }), !0) : !1;
  };
}
function Le(s, i) {
  var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : C(s);
  if (!h(s)) return !1;
  var _iterator33 = _createForOfIteratorHelper(s.getAttributeKeys()),
    _step33;
  try {
    for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
      var t = _step33.value;
      if (!(t.startsWith("selection:") || t == "htmlEmptyBlock") && !i.includes(t)) return !1;
    }
  } catch (err) {
    _iterator33.e(err);
  } finally {
    _iterator33.f();
  }
  return e.length < 2;
}
var M = ["listType", "listIndent", "listItemId"];
var V = /*#__PURE__*/function (_w2) {
  function V(e) {
    var _this0;
    _classCallCheck(this, V);
    _this0 = _callSuper(this, V, [e]);
    p(_this0, "_downcastStrategies", []);
    e.config.define("list.multiBlock", !0);
    return _this0;
  }
  _inherits(V, _w2);
  return _createClass(V, [{
    key: "init",
    value: function init() {
      var e = this.editor,
        t = e.model,
        n = e.config.get("list.multiBlock");
      if (e.plugins.has("LegacyListEditing")) throw new De("list-feature-conflict", this, {
        conflictPlugin: "LegacyListEditing"
      });
      t.schema.register("$listItem", {
        allowAttributes: M
      }), n ? (t.schema.extend("$container", {
        allowAttributesOf: "$listItem"
      }), t.schema.extend("$block", {
        allowAttributesOf: "$listItem"
      }), t.schema.extend("$blockObject", {
        allowAttributesOf: "$listItem"
      })) : t.schema.register("listItem", {
        inheritAllFrom: "$block",
        allowAttributesOf: "$listItem"
      });
      for (var _i5 = 0, _M = M; _i5 < _M.length; _i5++) {
        var r = _M[_i5];
        t.schema.setAttributeProperties(r, {
          copyOnReplace: !0
        });
      }
      e.commands.add("numberedList", new E(e, "numbered")), e.commands.add("bulletedList", new E(e, "bulleted")), e.commands.add("customNumberedList", new E(e, "customNumbered", {
        multiLevel: !0
      })), e.commands.add("customBulletedList", new E(e, "customBulleted", {
        multiLevel: !0
      })), e.commands.add("indentList", new re(e, "forward")), e.commands.add("outdentList", new re(e, "backward")), e.commands.add("splitListItemBefore", new ce(e, "before")), e.commands.add("splitListItemAfter", new ce(e, "after")), n && (e.commands.add("mergeListItemBackward", new le(e, "backward")), e.commands.add("mergeListItemForward", new le(e, "forward"))), this._setupDeleteIntegration(), this._setupEnterIntegration(), this._setupTabIntegration(), this._setupClipboardIntegration(), this._setupAccessibilityIntegration();
    }
  }, {
    key: "afterInit",
    value: function afterInit() {
      var t = this.editor.commands,
        n = t.get("indent"),
        r = t.get("outdent");
      n && n.registerChildCommand(t.get("indentList"), {
        priority: "high"
      }), r && r.registerChildCommand(t.get("outdentList"), {
        priority: "lowest"
      }), this._setupModelPostFixing(), this._setupConversion();
    }
  }, {
    key: "registerDowncastStrategy",
    value: function registerDowncastStrategy(e) {
      this._downcastStrategies.push(e);
    }
  }, {
    key: "getListAttributeNames",
    value: function getListAttributeNames() {
      return [].concat(M, _toConsumableArray(this._downcastStrategies.map(function (e) {
        return e.attributeName;
      })));
    }
  }, {
    key: "_setupDeleteIntegration",
    value: function _setupDeleteIntegration() {
      var e = this.editor,
        t = e.commands.get("mergeListItemBackward"),
        n = e.commands.get("mergeListItemForward");
      this.listenTo(e.editing.view.document, "delete", function (r, o) {
        var l = e.model.document.selection;
        P(e.model) || e.model.change(function () {
          var c = l.getFirstPosition();
          if (l.isCollapsed && o.direction == "backward") {
            if (!c.isAtStart) return;
            var a = c.parent;
            if (!h(a)) return;
            if (!y.first(a, {
              sameAttributes: "listType",
              sameIndent: !0
            }) && a.getAttribute("listIndent") === 0) ne(a) || e.execute("splitListItemAfter"), e.execute("outdentList");else {
              if (!t || !t.isEnabled) return;
              t.execute({
                shouldMergeOnBlocksContentLevel: de(e.model, "backward")
              });
            }
            o.preventDefault(), r.stop();
          } else {
            if (l.isCollapsed && !l.getLastPosition().isAtEnd || !n || !n.isEnabled) return;
            n.execute({
              shouldMergeOnBlocksContentLevel: de(e.model, "forward")
            }), o.preventDefault(), r.stop();
          }
        });
      }, {
        context: "li"
      });
    }
  }, {
    key: "_setupEnterIntegration",
    value: function _setupEnterIntegration() {
      var e = this.editor,
        t = e.model,
        n = e.commands,
        r = n.get("enter");
      this.listenTo(e.editing.view.document, "enter", function (o, l) {
        var c = t.document,
          a = c.selection.getFirstPosition().parent;
        if (c.selection.isCollapsed && h(a) && a.isEmpty && !l.isSoft) {
          var u = k(a),
            d = ne(a);
          u && d ? (e.execute("outdentList"), l.preventDefault(), o.stop()) : u && !d ? (e.execute("splitListItemAfter"), l.preventDefault(), o.stop()) : d && (e.execute("splitListItemBefore"), l.preventDefault(), o.stop());
        }
      }, {
        context: "li"
      }), this.listenTo(r, "afterExecute", function () {
        var o = n.get("splitListItemBefore");
        if (o.refresh(), !o.isEnabled) return;
        var c = e.model.document.selection.getLastPosition().parent;
        C(c).length === 2 && o.execute();
      });
    }
  }, {
    key: "_setupTabIntegration",
    value: function _setupTabIntegration() {
      var _this1 = this;
      var e = this.editor;
      this.listenTo(e.editing.view.document, "tab", function (t, n) {
        var r = n.shiftKey ? "outdentList" : "indentList";
        _this1.editor.commands.get(r).isEnabled && (e.execute(r), n.stopPropagation(), n.preventDefault(), t.stop());
      }, {
        context: "li"
      });
    }
  }, {
    key: "_setupConversion",
    value: function _setupConversion() {
      var _this10 = this;
      var e = this.editor,
        t = e.model,
        n = this.getListAttributeNames(),
        r = e.config.get("list.multiBlock"),
        o = r ? "paragraph" : "listItem";
      e.conversion.for("upcast").elementToElement({
        view: "li",
        model: function model(c, _ref18) {
          var a = _ref18.writer;
          return a.createElement(o, {
            listType: ""
          });
        }
      }).elementToElement({
        view: "p",
        model: function model(c, _ref19) {
          var a = _ref19.writer;
          return c.parent && c.parent.is("element", "li") ? a.createElement(o, {
            listType: ""
          }) : null;
        },
        converterPriority: "high"
      }).add(function (c) {
        c.on("element:li", _t());
      }), r || e.conversion.for("downcast").elementToElement({
        model: "listItem",
        view: "p"
      }), e.conversion.for("editingDowncast").elementToElement({
        model: o,
        view: ue(n),
        converterPriority: "high"
      }).add(function (c) {
        c.on("attribute", ae(n, _this10._downcastStrategies, t)), c.on("remove", xt(t.schema));
      }), e.conversion.for("dataDowncast").elementToElement({
        model: o,
        view: ue(n, {
          dataPipeline: !0
        }),
        converterPriority: "high"
      }).add(function (c) {
        c.on("attribute", ae(n, _this10._downcastStrategies, t, {
          dataPipeline: !0
        }));
      });
      var l = Bt(this._downcastStrategies, e.editing.view);
      e.editing.mapper.on("modelToViewPosition", l), e.data.mapper.on("modelToViewPosition", l), this.listenTo(t.document, "change:data", Ct(t, e.editing, n, this), {
        priority: "high"
      }), this.on("checkAttributes:item", function (c, _ref20) {
        var a = _ref20.viewElement,
          u = _ref20.modelAttributes;
        a.id != u.listItemId && (c.return = !0, c.stop());
      }), this.on("checkAttributes:list", function (c, _ref21) {
        var a = _ref21.viewElement,
          u = _ref21.modelAttributes;
        (a.name != we(u.listType) || a.id != Ae(u.listType, u.listIndent)) && (c.return = !0, c.stop());
      });
    }
  }, {
    key: "_setupModelPostFixing",
    value: function _setupModelPostFixing() {
      var _this11 = this;
      var e = this.editor.model,
        t = this.getListAttributeNames();
      e.document.registerPostFixer(function (n) {
        return Ot(e, n, t, _this11);
      }), this.on("postFixer", function (n, _ref22) {
        var r = _ref22.listNodes,
          o = _ref22.writer;
        n.return = vt(r, o) || n.return;
      }, {
        priority: "high"
      }), this.on("postFixer", function (n, _ref23) {
        var r = _ref23.listNodes,
          o = _ref23.writer,
          l = _ref23.seenIds;
        n.return = St(r, l, o) || n.return;
      }, {
        priority: "high"
      });
    }
  }, {
    key: "_setupClipboardIntegration",
    value: function _setupClipboardIntegration() {
      var e = this.editor.model,
        t = this.editor.plugins.get("ClipboardPipeline");
      this.listenTo(e, "insertContent", Rt(e), {
        priority: "high"
      }), this.listenTo(t, "outputTransformation", function (n, r) {
        e.change(function (o) {
          var l = Array.from(r.content.getChildren()),
            c = l[l.length - 1];
          if (l.length > 1 && c.is("element") && c.isEmpty && l.slice(0, -1).every(h) && o.remove(c), r.method == "copy" || r.method == "cut") {
            var a = Array.from(r.content.getChildren());
            B(a) && K(a, o);
          }
        });
      });
    }
  }, {
    key: "_setupAccessibilityIntegration",
    value: function _setupAccessibilityIntegration() {
      var e = this.editor,
        t = e.t;
      e.accessibility.addKeystrokeInfoGroup({
        id: "list",
        label: t("Keystrokes that can be used in a list"),
        keystrokes: [{
          label: t("Increase list item indent"),
          keystroke: "Tab"
        }, {
          label: t("Decrease list item indent"),
          keystroke: "Shift+Tab"
        }]
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "ListEditing";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }, {
    key: "requires",
    get: function get() {
      return [Me, Re, wt, qe];
    }
  }]);
}(w);
function Ot(s, i, e, t) {
  var n = s.document.differ.getChanges(),
    r = new Set(),
    o = new Set(),
    l = t.editor.config.get("list.multiBlock");
  var c = !1;
  var _iterator34 = _createForOfIteratorHelper(n),
    _step34;
  try {
    for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
      var u = _step34.value;
      if (u.type == "insert" && u.name != "$text") {
        var d = u.position.nodeAfter;
        if (!s.schema.checkAttribute(d, "listItemId")) for (var _i6 = 0, _Array$from = Array.from(d.getAttributeKeys()); _i6 < _Array$from.length; _i6++) {
          var f = _Array$from[_i6];
          e.includes(f) && (i.removeAttribute(f, d), c = !0);
        }
        I(u.position, o, r), u.attributes.has("listItemId") || I(u.position.getShiftedBy(u.length), o, r);
        var _iterator36 = _createForOfIteratorHelper(s.createRangeIn(d)),
          _step36;
        try {
          for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
            var _ref24 = _step36.value;
            var _f4 = _ref24.item;
            var m = _ref24.previousPosition;
            h(_f4) && I(m, o, r);
          }
        } catch (err) {
          _iterator36.e(err);
        } finally {
          _iterator36.f();
        }
      } else u.type == "remove" ? I(u.position, o, r) : u.type == "attribute" && e.includes(u.attributeKey) && (I(u.range.start, o, r), u.attributeNewValue === null && I(u.range.start.getShiftedBy(1), o, r));
      if (!l && u.type == "attribute" && M.includes(u.attributeKey)) {
        var _d2 = u.range.start.nodeAfter;
        u.attributeNewValue === null && _d2 && _d2.is("element", "listItem") ? (i.rename(_d2, "paragraph"), c = !0) : u.attributeOldValue === null && _d2 && _d2.is("element") && _d2.name != "listItem" && (i.rename(_d2, "listItem"), c = !0);
      }
    }
  } catch (err) {
    _iterator34.e(err);
  } finally {
    _iterator34.f();
  }
  var a = new Set();
  var _iterator35 = _createForOfIteratorHelper(o.values()),
    _step35;
  try {
    for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
      var _u3 = _step35.value;
      c = t.fire("postFixer", {
        listNodes: new ht(_u3),
        listHead: _u3,
        writer: i,
        seenIds: a
      }) || c;
    }
  } catch (err) {
    _iterator35.e(err);
  } finally {
    _iterator35.f();
  }
  return c;
}
function Rt(s) {
  return function (i, _ref25) {
    var _ref26 = _slicedToArray(_ref25, 2),
      e = _ref26[0],
      t = _ref26[1];
    var n = e.is("documentFragment") ? Array.from(e.getChildren()) : [e];
    if (!n.length) return;
    var o = (t ? s.createSelection(t) : s.document.selection).getFirstPosition();
    var l;
    if (h(o.parent)) l = o.parent;else if (h(o.nodeBefore) && h(o.nodeAfter)) l = o.nodeBefore;else return;
    s.change(function (c) {
      var a = l.getAttribute("listType"),
        u = l.getAttribute("listIndent"),
        d = n[0].getAttribute("listIndent") || 0,
        f = Math.max(u - d, 0);
      var _iterator37 = _createForOfIteratorHelper(n),
        _step37;
      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
          var m = _step37.value;
          var g = h(m);
          l.is("element", "listItem") && m.is("element", "paragraph") && c.rename(m, "listItem"), c.setAttributes({
            listIndent: (g ? m.getAttribute("listIndent") : 0) + f,
            listItemId: g ? m.getAttribute("listItemId") : _.next(),
            listType: a
          }, m);
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
    });
  };
}
function de(s, i) {
  var e = s.document.selection;
  if (!e.isCollapsed) return !P(s);
  if (i === "forward") return !0;
  var n = e.getFirstPosition().parent,
    r = n.previousSibling;
  return s.schema.isObject(r) ? !1 : r.isEmpty ? !0 : B([n, r]);
}
function z(s, i, e, t) {
  s.ui.componentFactory.add(i, function () {
    var n = fe(Z, s, i, e, t);
    return n.set({
      tooltip: !0,
      isToggleable: !0
    }), n;
  }), s.ui.componentFactory.add("menuBar:".concat(i), function () {
    var n = fe(Ge, s, i, e, t);
    return n.set({
      role: "menuitemcheckbox",
      isToggleable: !0
    }), n;
  });
}
function fe(s, i, e, t, n) {
  var r = i.commands.get(e),
    o = new s(i.locale);
  return o.set({
    label: t,
    icon: n
  }), o.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), o.on("execute", function () {
    i.execute(e), i.editing.view.focus();
  }), o;
}
var Mt = /*#__PURE__*/function (_w3) {
  function Mt() {
    _classCallCheck(this, Mt);
    return _callSuper(this, Mt, arguments);
  }
  _inherits(Mt, _w3);
  return _createClass(Mt, [{
    key: "init",
    value: function init() {
      var i = this.editor.t;
      this.editor.ui.componentFactory.has("numberedList") || z(this.editor, "numberedList", i("Numbered List"), Q), this.editor.ui.componentFactory.has("bulletedList") || z(this.editor, "bulletedList", i("Bulleted List"), J);
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "ListUI";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(w);
var pi = /*#__PURE__*/function (_w4) {
  function pi() {
    _classCallCheck(this, pi);
    return _callSuper(this, pi, arguments);
  }
  _inherits(pi, _w4);
  return _createClass(pi, null, [{
    key: "requires",
    get: function get() {
      return [V, Mt];
    }
  }, {
    key: "pluginName",
    get: function get() {
      return "List";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(w);
var Dt = /*#__PURE__*/function (_v5) {
  function Dt() {
    _classCallCheck(this, Dt);
    return _callSuper(this, Dt, arguments);
  }
  _inherits(Dt, _v5);
  return _createClass(Dt, [{
    key: "refresh",
    value: function refresh() {
      var i = this._getValue();
      this.value = i, this.isEnabled = i != null;
    }
  }, {
    key: "execute",
    value: function execute() {
      var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref27$startIndex = _ref27.startIndex,
        i = _ref27$startIndex === void 0 ? 1 : _ref27$startIndex;
      var e = this.editor.model,
        t = e.document;
      var n = Array.from(t.selection.getSelectedBlocks()).filter(function (r) {
        return h(r) && D(r.getAttribute("listType"));
      });
      n = $(n), e.change(function (r) {
        var _iterator38 = _createForOfIteratorHelper(n),
          _step38;
        try {
          for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
            var o = _step38.value;
            r.setAttribute("listStart", i >= 0 ? i : 1, o);
          }
        } catch (err) {
          _iterator38.e(err);
        } finally {
          _iterator38.f();
        }
      });
    }
  }, {
    key: "_getValue",
    value: function _getValue() {
      var e = this.editor.model.document,
        t = U(e.selection.getSelectedBlocks());
      return t && h(t) && D(t.getAttribute("listType")) ? t.getAttribute("listStart") : null;
    }
  }]);
}(v);
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
var Te = {},
  ve = {},
  Se = {},
  _e = [{
    listStyle: "disc",
    typeAttribute: "disc",
    listType: "bulleted"
  }, {
    listStyle: "circle",
    typeAttribute: "circle",
    listType: "bulleted"
  }, {
    listStyle: "square",
    typeAttribute: "square",
    listType: "bulleted"
  }, {
    listStyle: "decimal",
    typeAttribute: "1",
    listType: "numbered"
  }, {
    listStyle: "decimal-leading-zero",
    typeAttribute: null,
    listType: "numbered"
  }, {
    listStyle: "lower-roman",
    typeAttribute: "i",
    listType: "numbered"
  }, {
    listStyle: "upper-roman",
    typeAttribute: "I",
    listType: "numbered"
  }, {
    listStyle: "lower-alpha",
    typeAttribute: "a",
    listType: "numbered"
  }, {
    listStyle: "upper-alpha",
    typeAttribute: "A",
    listType: "numbered"
  }, {
    listStyle: "lower-latin",
    typeAttribute: "a",
    listType: "numbered"
  }, {
    listStyle: "upper-latin",
    typeAttribute: "A",
    listType: "numbered"
  }];
for (var _i7 = 0, _e3 = _e; _i7 < _e3.length; _i7++) {
  var _ref28 = _e3[_i7];
  var s = _ref28.listStyle;
  var i = _ref28.typeAttribute;
  var e = _ref28.listType;
  Te[s] = e, ve[s] = i, i && (Se[i] = s);
}
function Ce() {
  return _e.map(function (s) {
    return s.listStyle;
  });
}
function ee(s) {
  return Te[s] || null;
}
function xe(s) {
  return Se[s] || null;
}
function G(s) {
  return ve[s] || null;
}
function Ut(s) {
  switch (s) {
    case "lower-alpha":
      return "lower-latin";
    case "upper-alpha":
      return "upper-latin";
    default:
      return s;
  }
}
var $t = /*#__PURE__*/function (_v6) {
  function $t(e, t, n) {
    var _this12;
    _classCallCheck(this, $t);
    _this12 = _callSuper(this, $t, [e]);
    p(_this12, "defaultType");
    p(_this12, "_supportedTypes");
    _this12.defaultType = t, _this12._supportedTypes = n;
    return _this12;
  }
  _inherits($t, _v6);
  return _createClass($t, [{
    key: "refresh",
    value: function refresh() {
      this.value = this._getValue(), this.isEnabled = this._checkEnabled();
    }
  }, {
    key: "execute",
    value: function execute() {
      var _this13 = this;
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t = this.editor.model,
        n = t.document;
      t.change(function (r) {
        _this13._tryToConvertItemsToList(e);
        var o = Array.from(n.selection.getSelectedBlocks()).filter(function (l) {
          return l.hasAttribute("listType");
        });
        if (o.length) {
          o = $(o);
          var _iterator39 = _createForOfIteratorHelper(o),
            _step39;
          try {
            for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
              var l = _step39.value;
              r.setAttribute("listStyle", e.type || _this13.defaultType, l);
            }
          } catch (err) {
            _iterator39.e(err);
          } finally {
            _iterator39.f();
          }
        }
      });
    }
  }, {
    key: "isStyleTypeSupported",
    value: function isStyleTypeSupported(e) {
      return this._supportedTypes ? this._supportedTypes.includes(e) : !0;
    }
  }, {
    key: "_getValue",
    value: function _getValue() {
      var e = U(this.editor.model.document.selection.getSelectedBlocks());
      return h(e) ? e.getAttribute("listStyle") : null;
    }
  }, {
    key: "_checkEnabled",
    value: function _checkEnabled() {
      var e = this.editor,
        t = e.commands.get("numberedList"),
        n = e.commands.get("bulletedList");
      return t.isEnabled || n.isEnabled;
    }
  }, {
    key: "_tryToConvertItemsToList",
    value: function _tryToConvertItemsToList(e) {
      if (!e.type) return;
      var t = ee(e.type);
      if (!t) return;
      var n = this.editor,
        r = "".concat(t, "List");
      n.commands.get(r).value || n.execute(r);
    }
  }]);
}(v);
var Kt = /*#__PURE__*/function (_v7) {
  function Kt() {
    _classCallCheck(this, Kt);
    return _callSuper(this, Kt, arguments);
  }
  _inherits(Kt, _v7);
  return _createClass(Kt, [{
    key: "refresh",
    value: function refresh() {
      var i = this._getValue();
      this.value = i, this.isEnabled = i != null;
    }
  }, {
    key: "execute",
    value: function execute() {
      var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var e = this.editor.model,
        t = e.document;
      var n = Array.from(t.selection.getSelectedBlocks()).filter(function (r) {
        return h(r) && r.getAttribute("listType") == "numbered";
      });
      n = $(n), e.change(function (r) {
        var _iterator40 = _createForOfIteratorHelper(n),
          _step40;
        try {
          for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
            var o = _step40.value;
            r.setAttribute("listReversed", !!i.reversed, o);
          }
        } catch (err) {
          _iterator40.e(err);
        } finally {
          _iterator40.f();
        }
      });
    }
  }, {
    key: "_getValue",
    value: function _getValue() {
      var e = this.editor.model.document,
        t = U(e.selection.getSelectedBlocks());
      return h(t) && t.getAttribute("listType") == "numbered" ? t.getAttribute("listReversed") : null;
    }
  }]);
}(v);
/**
* @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
* For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
*/
function me(s) {
  return function (i, e, t) {
    var n = t.writer,
      r = t.schema,
      o = t.consumable;
    if (o.test(e.viewItem, s.viewConsumables) === !1) return;
    e.modelRange || Object.assign(e, t.convertChildren(e.viewItem, e.modelCursor));
    var l = !1;
    var _iterator41 = _createForOfIteratorHelper(e.modelRange.getItems({
        shallow: !0
      })),
      _step41;
    try {
      for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
        var c = _step41.value;
        r.checkAttribute(c, s.attributeName) && s.appliesToListItem(c) && (c.hasAttribute(s.attributeName) || (n.setAttribute(s.attributeName, s.getAttributeOnUpcast(e.viewItem), c), l = !0));
      }
    } catch (err) {
      _iterator41.e(err);
    } finally {
      _iterator41.f();
    }
    l && o.consume(e.viewItem, s.viewConsumables);
  };
}
var Wt = /*#__PURE__*/function (_w5) {
  function Wt() {
    _classCallCheck(this, Wt);
    return _callSuper(this, Wt, arguments);
  }
  _inherits(Wt, _w5);
  return _createClass(Wt, [{
    key: "getAllSupportedStyleTypes",
    value: function getAllSupportedStyleTypes() {
      return Ce();
    }
  }, {
    key: "getListTypeFromListStyleType",
    value: function getListTypeFromListStyleType(i) {
      return ee(i);
    }
  }, {
    key: "getListStyleTypeFromTypeAttribute",
    value: function getListStyleTypeFromTypeAttribute(i) {
      return xe(i);
    }
  }, {
    key: "getTypeAttributeFromListStyleType",
    value: function getTypeAttributeFromListStyleType(i) {
      return G(i);
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "ListPropertiesUtils";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(w);
function Ee(s) {
  var i = s.startIndex,
    e = s.reversed,
    t = s.styles;
  return {
    styles: jt(t),
    startIndex: i || !1,
    reversed: e || !1
  };
}
function jt(s) {
  var i = {
    listTypes: ["bulleted", "numbered"],
    useAttribute: !1
  };
  return s === !0 || (s ? Array.isArray(s) || typeof s == "string" ? i.listTypes = L(s) : (i.listTypes = s.listTypes ? L(s.listTypes) : i.listTypes, i.useAttribute = !!s.useAttribute, s.listStyleTypes && (i.listStyleTypes = s.listStyleTypes)) : i.listTypes = []), i;
}
var x = "default";
var qt = /*#__PURE__*/function (_w6) {
  function qt(i) {
    var _this14;
    _classCallCheck(this, qt);
    _this14 = _callSuper(this, qt, [i]), i.config.define("list.properties", {
      styles: !0,
      startIndex: !1,
      reversed: !1
    });
    return _this14;
  }
  _inherits(qt, _w6);
  return _createClass(qt, [{
    key: "init",
    value: function init() {
      var i = this.editor,
        e = i.model,
        t = i.plugins.get(V),
        n = i.config.get("list.properties"),
        r = Ht(n);
      var _iterator42 = _createForOfIteratorHelper(r),
        _step42;
      try {
        var _loop2 = function _loop2() {
          var o = _step42.value;
          o.addCommand(i), e.schema.extend("$listItem", {
            allowAttributes: o.attributeName
          }), t.registerDowncastStrategy({
            scope: "list",
            attributeName: o.attributeName,
            setAttributeOnDowncast: function setAttributeOnDowncast(l, c, a) {
              o.setAttributeOnDowncast(l, c, a);
            }
          });
        };
        for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator42.e(err);
      } finally {
        _iterator42.f();
      }
      i.conversion.for("upcast").add(function (o) {
        var _iterator43 = _createForOfIteratorHelper(r),
          _step43;
        try {
          for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
            var l = _step43.value;
            o.on("element:ol", me(l)), o.on("element:ul", me(l));
          }
        } catch (err) {
          _iterator43.e(err);
        } finally {
          _iterator43.f();
        }
      }), t.on("checkAttributes:list", function (o, _ref29) {
        var l = _ref29.viewElement,
          c = _ref29.modelAttributes;
        var _iterator44 = _createForOfIteratorHelper(r),
          _step44;
        try {
          for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
            var a = _step44.value;
            a.getAttributeOnUpcast(l) != c[a.attributeName] && (o.return = !0, o.stop());
          }
        } catch (err) {
          _iterator44.e(err);
        } finally {
          _iterator44.f();
        }
      }), this.listenTo(i.commands.get("indentList"), "afterExecute", function (o, l) {
        e.change(function (c) {
          var _iterator45 = _createForOfIteratorHelper(l),
            _step45;
          try {
            for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
              var a = _step45.value;
              var _iterator46 = _createForOfIteratorHelper(r),
                _step46;
              try {
                for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
                  var u = _step46.value;
                  u.appliesToListItem(a) && c.setAttribute(u.attributeName, u.defaultValue, a);
                }
              } catch (err) {
                _iterator46.e(err);
              } finally {
                _iterator46.f();
              }
            }
          } catch (err) {
            _iterator45.e(err);
          } finally {
            _iterator45.f();
          }
        });
      }), t.on("postFixer", function (o, _ref30) {
        var l = _ref30.listNodes,
          c = _ref30.writer;
        var _iterator47 = _createForOfIteratorHelper(l),
          _step47;
        try {
          for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
            var _ref31 = _step47.value;
            var a = _ref31.node;
            var _iterator48 = _createForOfIteratorHelper(r),
              _step48;
            try {
              for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
                var u = _step48.value;
                u.hasValidAttribute(a) || (u.appliesToListItem(a) ? c.setAttribute(u.attributeName, u.defaultValue, a) : c.removeAttribute(u.attributeName, a), o.return = !0);
              }
            } catch (err) {
              _iterator48.e(err);
            } finally {
              _iterator48.f();
            }
          }
        } catch (err) {
          _iterator47.e(err);
        } finally {
          _iterator47.f();
        }
      }), t.on("postFixer", function (o, _ref32) {
        var l = _ref32.listNodes,
          c = _ref32.writer;
        var _iterator49 = _createForOfIteratorHelper(l),
          _step49;
        try {
          for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
            var _ref33 = _step49.value;
            var a = _ref33.node;
            var u = _ref33.previousNodeInList;
            if (u && u.getAttribute("listType") == a.getAttribute("listType")) {
              var _iterator50 = _createForOfIteratorHelper(r),
                _step50;
              try {
                for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
                  var d = _step50.value;
                  var f = d.attributeName;
                  if (!d.appliesToListItem(a)) continue;
                  var m = u.getAttribute(f);
                  a.getAttribute(f) != m && (c.setAttribute(f, m, a), o.return = !0);
                }
              } catch (err) {
                _iterator50.e(err);
              } finally {
                _iterator50.f();
              }
            }
          }
        } catch (err) {
          _iterator49.e(err);
        } finally {
          _iterator49.f();
        }
      });
    }
  }], [{
    key: "requires",
    get: function get() {
      return [V, Wt];
    }
  }, {
    key: "pluginName",
    get: function get() {
      return "ListPropertiesEditing";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(w);
function Ht(s) {
  var i = [],
    e = Ee(s);
  if (s.styles) {
    var t = e.styles.useAttribute;
    i.push({
      attributeName: "listStyle",
      defaultValue: x,
      viewConsumables: {
        styles: "list-style-type"
      },
      addCommand: function addCommand(n) {
        var r = Ce();
        t && (r = r.filter(function (o) {
          return !!G(o);
        })), n.commands.add("listStyle", new $t(n, x, r));
      },
      appliesToListItem: function appliesToListItem(n) {
        return n.getAttribute("listType") == "numbered" || n.getAttribute("listType") == "bulleted";
      },
      hasValidAttribute: function hasValidAttribute(n) {
        if (!this.appliesToListItem(n)) return !n.hasAttribute("listStyle");
        if (!n.hasAttribute("listStyle")) return !1;
        var r = n.getAttribute("listStyle");
        return r == x ? !0 : ee(r) == n.getAttribute("listType");
      },
      setAttributeOnDowncast: function setAttributeOnDowncast(n, r, o) {
        if (r && r !== x) if (t) {
          var l = G(r);
          if (l) {
            n.setAttribute("type", l, o);
            return;
          }
        } else {
          n.setStyle("list-style-type", r, o);
          return;
        }
        n.removeStyle("list-style-type", o), n.removeAttribute("type", o);
      },
      getAttributeOnUpcast: function getAttributeOnUpcast(n) {
        var r = n.getStyle("list-style-type");
        if (r) return Ut(r);
        var o = n.getAttribute("type");
        return o ? xe(o) : x;
      }
    });
  }
  return s.reversed && i.push({
    attributeName: "listReversed",
    defaultValue: !1,
    viewConsumables: {
      attributes: "reversed"
    },
    addCommand: function addCommand(t) {
      t.commands.add("listReversed", new Kt(t));
    },
    appliesToListItem: function appliesToListItem(t) {
      return t.getAttribute("listType") == "numbered";
    },
    hasValidAttribute: function hasValidAttribute(t) {
      return this.appliesToListItem(t) == t.hasAttribute("listReversed");
    },
    setAttributeOnDowncast: function setAttributeOnDowncast(t, n, r) {
      n ? t.setAttribute("reversed", "reversed", r) : t.removeAttribute("reversed", r);
    },
    getAttributeOnUpcast: function getAttributeOnUpcast(t) {
      return t.hasAttribute("reversed");
    }
  }), s.startIndex && i.push({
    attributeName: "listStart",
    defaultValue: 1,
    viewConsumables: {
      attributes: "start"
    },
    addCommand: function addCommand(t) {
      t.commands.add("listStart", new Dt(t));
    },
    appliesToListItem: function appliesToListItem(t) {
      return D(t.getAttribute("listType"));
    },
    hasValidAttribute: function hasValidAttribute(t) {
      return this.appliesToListItem(t) == t.hasAttribute("listStart");
    },
    setAttributeOnDowncast: function setAttributeOnDowncast(t, n, r) {
      n == 0 || n > 1 ? t.setAttribute("start", n, r) : t.removeAttribute("start", r);
    },
    getAttributeOnUpcast: function getAttributeOnUpcast(t) {
      var n = t.getAttribute("start");
      return n >= 0 ? n : 1;
    }
  }), i;
}
var Be = /*#__PURE__*/function (_se) {
  function Be(e, _ref34) {
    var _this15;
    var t = _ref34.enabledProperties,
      n = _ref34.styleButtonViews,
      r = _ref34.styleGridAriaLabel;
    _classCallCheck(this, Be);
    _this15 = _callSuper(this, Be, [e]);
    p(_this15, "children");
    p(_this15, "stylesView", null);
    p(_this15, "additionalPropertiesCollapsibleView", null);
    p(_this15, "startIndexFieldView", null);
    p(_this15, "reversedSwitchButtonView", null);
    p(_this15, "focusTracker", new te());
    p(_this15, "keystrokes", new ie());
    p(_this15, "focusables", new Je());
    p(_this15, "focusCycler");
    var o = ["ck", "ck-list-properties"];
    _this15.children = _this15.createCollection(), _this15.focusCycler = new Qe({
      focusables: _this15.focusables,
      focusTracker: _this15.focusTracker,
      keystrokeHandler: _this15.keystrokes,
      actions: {
        focusPrevious: "shift + tab",
        focusNext: "tab"
      }
    }), n && n.length ? (_this15.stylesView = _this15._createStylesView(n, r), _this15.children.add(_this15.stylesView)) : o.push("ck-list-properties_without-styles"), (t.startIndex || t.reversed) && (_this15._addNumberedListPropertyViews(t), o.push("ck-list-properties_with-numbered-properties")), _this15.setTemplate({
      tag: "div",
      attributes: {
        class: o
      },
      children: _this15.children
    });
    return _this15;
  }
  _inherits(Be, _se);
  return _createClass(Be, [{
    key: "render",
    value: function render() {
      var _this16 = this;
      if (_superPropGet(Be, "render", this, 3)([]), this.stylesView) {
        this.focusables.add(this.stylesView), this.focusTracker.add(this.stylesView.element), (this.startIndexFieldView || this.reversedSwitchButtonView) && (this.focusables.add(this.children.last.buttonView), this.focusTracker.add(this.children.last.buttonView.element));
        var _iterator51 = _createForOfIteratorHelper(this.stylesView.children),
          _step51;
        try {
          for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
            var _e4 = _step51.value;
            this.stylesView.focusTracker.add(_e4.element);
          }
        } catch (err) {
          _iterator51.e(err);
        } finally {
          _iterator51.f();
        }
        Xe({
          keystrokeHandler: this.stylesView.keystrokes,
          focusTracker: this.stylesView.focusTracker,
          gridItems: this.stylesView.children,
          numberOfColumns: function numberOfColumns() {
            return je.window.getComputedStyle(_this16.stylesView.element).getPropertyValue("grid-template-columns").split(" ").length;
          },
          uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
        });
      }
      if (this.startIndexFieldView) {
        this.focusables.add(this.startIndexFieldView), this.focusTracker.add(this.startIndexFieldView.element);
        var _e5 = function _e5(t) {
          return t.stopPropagation();
        };
        this.keystrokes.set("arrowright", _e5), this.keystrokes.set("arrowleft", _e5), this.keystrokes.set("arrowup", _e5), this.keystrokes.set("arrowdown", _e5);
      }
      this.reversedSwitchButtonView && (this.focusables.add(this.reversedSwitchButtonView), this.focusTracker.add(this.reversedSwitchButtonView.element)), this.keystrokes.listenTo(this.element);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.focusCycler.focusFirst();
    }
  }, {
    key: "focusLast",
    value: function focusLast() {
      this.focusCycler.focusLast();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(Be, "destroy", this, 3)([]), this.focusTracker.destroy(), this.keystrokes.destroy();
    }
  }, {
    key: "_createStylesView",
    value: function _createStylesView(e, t) {
      var n = new se(this.locale);
      return n.children = n.createCollection(), n.children.addMany(e), n.setTemplate({
        tag: "div",
        attributes: {
          "aria-label": t,
          class: ["ck", "ck-list-styles-list"]
        },
        children: n.children
      }), n.children.delegate("execute").to(this), n.focus = function () {
        var _iterator52 = _createForOfIteratorHelper(this.children),
          _step52;
        try {
          for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
            var r = _step52.value;
            if (r instanceof Z && r.isOn) {
              r.focus();
              return;
            }
          }
        } catch (err) {
          _iterator52.e(err);
        } finally {
          _iterator52.f();
        }
        this.children.first.focus();
      }, n.focusTracker = new te(), n.keystrokes = new ie(), n.render(), n.keystrokes.listenTo(n.element), n;
    }
  }, {
    key: "_addNumberedListPropertyViews",
    value: function _addNumberedListPropertyViews(e) {
      var _this17 = this;
      var t = this.locale.t,
        n = [];
      e.startIndex && (this.startIndexFieldView = this._createStartIndexField(), n.push(this.startIndexFieldView)), e.reversed && (this.reversedSwitchButtonView = this._createReversedSwitchButton(), n.push(this.reversedSwitchButtonView)), this.stylesView ? (this.additionalPropertiesCollapsibleView = new et(this.locale, n), this.additionalPropertiesCollapsibleView.set({
        label: t("List properties"),
        isCollapsed: !0
      }), this.additionalPropertiesCollapsibleView.buttonView.bind("isEnabled").toMany(n, "isEnabled", function () {
        for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
          r[_key] = arguments[_key];
        }
        return r.some(function (o) {
          return o;
        });
      }), this.additionalPropertiesCollapsibleView.buttonView.on("change:isEnabled", function (r, o, l) {
        l || (_this17.additionalPropertiesCollapsibleView.isCollapsed = !0);
      }), this.children.add(this.additionalPropertiesCollapsibleView)) : this.children.addMany(n);
    }
  }, {
    key: "_createStartIndexField",
    value: function _createStartIndexField() {
      var _this18 = this;
      var e = this.locale.t,
        t = new tt(this.locale, it);
      return t.set({
        label: e("Start at"),
        class: "ck-numbered-list-properties__start-index"
      }), t.fieldView.set({
        min: 0,
        step: 1,
        value: 1,
        inputMode: "numeric"
      }), t.fieldView.on("input", function () {
        var n = t.fieldView.element,
          r = n.valueAsNumber;
        if (Number.isNaN(r)) {
          t.errorText = e("Invalid start index value.");
          return;
        }
        n.checkValidity() ? _this18.fire("listStart", {
          startIndex: r
        }) : t.errorText = e("Start index must be greater than 0.");
      }), t;
    }
  }, {
    key: "_createReversedSwitchButton",
    value: function _createReversedSwitchButton() {
      var e = this.locale.t,
        t = new st(this.locale);
      return t.set({
        withText: !0,
        label: e("Reversed order"),
        class: "ck-numbered-list-properties__reversed-order"
      }), t.delegate("execute").to(this, "listReversed"), t;
    }
  }]);
}(se);
var Yt = /*#__PURE__*/function (_w7) {
  function Yt() {
    _classCallCheck(this, Yt);
    return _callSuper(this, Yt, arguments);
  }
  _inherits(Yt, _w7);
  return _createClass(Yt, [{
    key: "init",
    value: function init() {
      var i = this.editor,
        e = i.locale.t,
        t = i.config.get("list.properties"),
        n = Ee(t),
        r = n.styles.listTypes;
      if (r.includes("bulleted")) {
        var o = [{
            label: e("Toggle the disc list style"),
            tooltip: e("Disc"),
            type: "disc",
            icon: nt
          }, {
            label: e("Toggle the circle list style"),
            tooltip: e("Circle"),
            type: "circle",
            icon: rt
          }, {
            label: e("Toggle the square list style"),
            tooltip: e("Square"),
            type: "square",
            icon: ot
          }],
          l = e("Bulleted List"),
          c = e("Bulleted list styles toolbar"),
          a = "bulletedList";
        i.ui.componentFactory.add(a, pe({
          editor: i,
          normalizedConfig: n,
          parentCommandName: a,
          buttonLabel: l,
          buttonIcon: J,
          styleGridAriaLabel: c,
          styleDefinitions: o
        })), i.ui.componentFactory.add("menuBar:".concat(a), he({
          editor: i,
          normalizedConfig: n,
          parentCommandName: a,
          buttonLabel: l,
          styleGridAriaLabel: c,
          styleDefinitions: o
        }));
      }
      if (r.includes("numbered") || t.startIndex || t.reversed) {
        var _o3 = [{
            label: e("Toggle the decimal list style"),
            tooltip: e("Decimal"),
            type: "decimal",
            icon: lt
          }, {
            label: e("Toggle the decimal with leading zero list style"),
            tooltip: e("Decimal with leading zero"),
            type: "decimal-leading-zero",
            icon: ct
          }, {
            label: e("Toggle the lower–roman list style"),
            tooltip: e("Lower–roman"),
            type: "lower-roman",
            icon: at
          }, {
            label: e("Toggle the upper–roman list style"),
            tooltip: e("Upper-roman"),
            type: "upper-roman",
            icon: ut
          }, {
            label: e("Toggle the lower–latin list style"),
            tooltip: e("Lower-latin"),
            type: "lower-latin",
            icon: dt
          }, {
            label: e("Toggle the upper–latin list style"),
            tooltip: e("Upper-latin"),
            type: "upper-latin",
            icon: ft
          }],
          _l = e("Numbered List"),
          _c = e("Numbered list styles toolbar"),
          _a3 = "numberedList";
        i.ui.componentFactory.add(_a3, pe({
          editor: i,
          normalizedConfig: n,
          parentCommandName: _a3,
          buttonLabel: _l,
          buttonIcon: Q,
          styleGridAriaLabel: _c,
          styleDefinitions: _o3
        })), r.includes("numbered") && i.ui.componentFactory.add("menuBar:".concat(_a3), he({
          editor: i,
          normalizedConfig: n,
          parentCommandName: _a3,
          buttonLabel: _l,
          styleGridAriaLabel: _c,
          styleDefinitions: _o3
        }));
      }
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "ListPropertiesUI";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(w);
function pe(_ref35) {
  var s = _ref35.editor,
    i = _ref35.normalizedConfig,
    e = _ref35.parentCommandName,
    t = _ref35.buttonLabel,
    n = _ref35.buttonIcon,
    r = _ref35.styleGridAriaLabel,
    o = _ref35.styleDefinitions;
  var l = s.commands.get(e);
  return function (c) {
    var a = He(c, Ye),
      u = a.buttonView;
    return a.bind("isEnabled").to(l), a.class = "ck-list-styles-dropdown", u.on("execute", function () {
      s.execute(e), s.editing.view.focus();
    }), u.set({
      label: t,
      icon: n,
      tooltip: !0,
      isToggleable: !0
    }), u.bind("isOn").to(l, "value", function (d) {
      return !!d;
    }), a.once("change:isOpen", function () {
      var d = zt({
        editor: s,
        normalizedConfig: i,
        dropdownView: a,
        parentCommandName: e,
        styleGridAriaLabel: r,
        styleDefinitions: o
      });
      a.panelView.children.add(d);
    }), a.on("execute", function () {
      s.editing.view.focus();
    }), a;
  };
}
function Pe(_ref36) {
  var s = _ref36.editor,
    i = _ref36.listStyleCommand,
    e = _ref36.parentCommandName;
  var t = s.locale,
    n = s.commands.get(e);
  return function (_ref37) {
    var r = _ref37.label,
      o = _ref37.type,
      l = _ref37.icon,
      c = _ref37.tooltip;
    var a = new Z(t);
    return a.set({
      label: r,
      icon: l,
      tooltip: c
    }), a.bind("isOn").to(i, "value", function (u) {
      return u === o;
    }), a.on("execute", function () {
      n.value ? i.value === o ? s.execute(e) : i.value !== o && s.execute("listStyle", {
        type: o
      }) : s.model.change(function () {
        s.execute("listStyle", {
          type: o
        });
      });
    }), a;
  };
}
function zt(_ref38) {
  var s = _ref38.editor,
    i = _ref38.normalizedConfig,
    e = _ref38.dropdownView,
    t = _ref38.parentCommandName,
    n = _ref38.styleDefinitions,
    r = _ref38.styleGridAriaLabel;
  var o = s.locale,
    l = _objectSpread(_objectSpread({}, i), t != "numberedList" ? {
      startIndex: !1,
      reversed: !1
    } : null),
    c = t.replace("List", "");
  var a = null;
  if (i.styles.listTypes.includes(c)) {
    var d = s.commands.get("listStyle"),
      f = Pe({
        editor: s,
        parentCommandName: t,
        listStyleCommand: d
      }),
      m = i.styles.listStyleTypes;
    var g = n;
    if (m) {
      var b = m[c];
      b && (g = n.filter(function (O) {
        return b.includes(O.type);
      }));
    }
    var A = Ve(d);
    a = g.filter(A).map(f);
  }
  var u = new Be(o, {
    styleGridAriaLabel: r,
    enabledProperties: l,
    styleButtonViews: a
  });
  if (i.styles.listTypes.includes(c) && Ze(e, function () {
    return u.stylesView.children.find(function (d) {
      return d.isOn;
    });
  }), l.startIndex) {
    var _d3 = s.commands.get("listStart");
    u.startIndexFieldView.bind("isEnabled").to(_d3), u.startIndexFieldView.fieldView.bind("value").to(_d3), u.on("listStart", function (f, m) {
      return s.execute("listStart", m);
    });
  }
  if (l.reversed) {
    var _d4 = s.commands.get("listReversed");
    u.reversedSwitchButtonView.bind("isEnabled").to(_d4), u.reversedSwitchButtonView.bind("isOn").to(_d4, "value", function (f) {
      return !!f;
    }), u.on("listReversed", function () {
      var f = _d4.value;
      s.execute("listReversed", {
        reversed: !f
      });
    });
  }
  return u.delegate("execute").to(e), u;
}
function he(_ref39) {
  var s = _ref39.editor,
    i = _ref39.normalizedConfig,
    e = _ref39.parentCommandName,
    t = _ref39.buttonLabel,
    n = _ref39.styleGridAriaLabel,
    r = _ref39.styleDefinitions;
  return function (o) {
    var l = new ze(o),
      c = s.commands.get(e),
      a = s.commands.get("listStyle"),
      u = Ve(a),
      d = Pe({
        editor: s,
        parentCommandName: e,
        listStyleCommand: a
      }),
      f = i.styles.listStyleTypes;
    var m = r;
    if (f) {
      var b = c.type,
        O = f[b];
      O && (m = r.filter(function (Ne) {
        return O.includes(Ne.type);
      }));
    }
    var g = m.filter(u).map(d),
      A = new Be(o, {
        styleGridAriaLabel: n,
        enabledProperties: _objectSpread(_objectSpread({}, i), {}, {
          startIndex: !1,
          reversed: !1
        }),
        styleButtonViews: g
      });
    return A.delegate("execute").to(l), l.buttonView.set({
      label: t,
      icon: e === "bulletedList" ? J : Q
    }), l.panelView.children.add(A), l.bind("isEnabled").to(c, "isEnabled"), l.on("execute", function () {
      s.editing.view.focus();
    }), l;
  };
}
function Ve(s) {
  return typeof s.isStyleTypeSupported == "function" ? function (i) {
    return s.isStyleTypeSupported(i.type);
  } : function () {
    return !0;
  };
}
var hi = /*#__PURE__*/function (_w8) {
  function hi() {
    _classCallCheck(this, hi);
    return _callSuper(this, hi, arguments);
  }
  _inherits(hi, _w8);
  return _createClass(hi, null, [{
    key: "requires",
    get: function get() {
      return [qt, Yt];
    }
  }, {
    key: "pluginName",
    get: function get() {
      return "ListProperties";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(w);
var Gt = /*#__PURE__*/function (_v8) {
  function Gt(i) {
    var _this19;
    _classCallCheck(this, Gt);
    _this19 = _callSuper(this, Gt, [i]), _this19.on("execute", function () {
      _this19.refresh();
    }, {
      priority: "highest"
    });
    return _this19;
  }
  _inherits(Gt, _v8);
  return _createClass(Gt, [{
    key: "refresh",
    value: function refresh() {
      var i = this._getSelectedItems();
      this.value = this._getValue(i), this.isEnabled = !!i.length;
    }
  }, {
    key: "execute",
    value: function execute() {
      var _this20 = this;
      var i = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.editor.model.change(function (e) {
        var t = _this20._getSelectedItems(),
          n = i.forceValue === void 0 ? !_this20._getValue(t) : i.forceValue;
        var _iterator53 = _createForOfIteratorHelper(t),
          _step53;
        try {
          for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
            var r = _step53.value;
            n ? e.setAttribute("todoListChecked", !0, r) : e.removeAttribute("todoListChecked", r);
          }
        } catch (err) {
          _iterator53.e(err);
        } finally {
          _iterator53.f();
        }
      });
    }
  }, {
    key: "_getValue",
    value: function _getValue(i) {
      return i.every(function (e) {
        return e.getAttribute("todoListChecked");
      });
    }
  }, {
    key: "_getSelectedItems",
    value: function _getSelectedItems() {
      var i = this.editor.model,
        e = i.schema,
        t = i.document.selection.getFirstRange(),
        n = t.start.parent,
        r = [];
      e.checkAttribute(n, "todoListChecked") && r.push.apply(r, _toConsumableArray(C(n)));
      var _iterator54 = _createForOfIteratorHelper(t.getItems({
          shallow: !0
        })),
        _step54;
      try {
        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
          var o = _step54.value;
          e.checkAttribute(o, "todoListChecked") && !r.includes(o) && r.push.apply(r, _toConsumableArray(C(o)));
        }
      } catch (err) {
        _iterator54.e(err);
      } finally {
        _iterator54.f();
      }
      return r;
    }
  }]);
}(v);
var Zt = /*#__PURE__*/function (_pt) {
  function Zt() {
    var _this21;
    _classCallCheck(this, Zt);
    _this21 = _callSuper(this, Zt, arguments);
    p(_this21, "domEventType", ["change"]);
    return _this21;
  }
  _inherits(Zt, _pt);
  return _createClass(Zt, [{
    key: "onDomEvent",
    value: function onDomEvent(e) {
      if (e.target) {
        var t = this.view.domConverter.mapDomToView(e.target);
        t && t.is("element", "input") && t.getAttribute("type") == "checkbox" && t.findAncestor({
          classes: "todo-list__label"
        }) && this.fire("todoCheckboxChange", e);
      }
    }
  }]);
}(pt);
var Jt = $e("Ctrl+Enter");
var Qt = /*#__PURE__*/function (_w9) {
  function Qt() {
    _classCallCheck(this, Qt);
    return _callSuper(this, Qt, arguments);
  }
  _inherits(Qt, _w9);
  return _createClass(Qt, [{
    key: "init",
    value: function init() {
      var _this22 = this;
      var i = this.editor,
        e = i.model,
        t = i.editing,
        n = i.plugins.get(V),
        o = i.config.get("list.multiBlock") ? "paragraph" : "listItem";
      i.commands.add("todoList", new E(i, "todo")), i.commands.add("checkTodoList", new Gt(i)), t.view.addObserver(Zt), e.schema.extend("$listItem", {
        allowAttributes: "todoListChecked"
      }), e.schema.addAttributeCheck(function (l) {
        var c = l.last;
        if (!c.getAttribute("listItemId") || c.getAttribute("listType") != "todo") return !1;
      }, "todoListChecked"), i.conversion.for("upcast").add(function (l) {
        l.on("element:input", ei()), l.on("element:li", Xt(), {
          priority: "low"
        }), l.on("element:label", j({
          name: "label",
          classes: "todo-list__label"
        })), l.on("element:label", j({
          name: "label",
          classes: ["todo-list__label", "todo-list__label_without-description"]
        })), l.on("element:span", j({
          name: "span",
          classes: "todo-list__label__description"
        })), l.on("element:ul", ti({
          name: "ul",
          classes: "todo-list"
        }));
      }), i.conversion.for("downcast").elementToElement({
        model: o,
        view: function view(l, _ref40) {
          var c = _ref40.writer;
          if (R(l, n.getListAttributeNames())) return c.createContainerElement("span", {
            class: "todo-list__label__description"
          });
        },
        converterPriority: "highest"
      }), n.registerDowncastStrategy({
        scope: "list",
        attributeName: "listType",
        setAttributeOnDowncast: function setAttributeOnDowncast(l, c, a) {
          c == "todo" ? l.addClass("todo-list", a) : l.removeClass("todo-list", a);
        }
      }), n.registerDowncastStrategy({
        scope: "itemMarker",
        attributeName: "todoListChecked",
        createElement: function createElement(l, c, _ref41) {
          var a = _ref41.dataPipeline;
          if (c.getAttribute("listType") != "todo") return null;
          var u = l.createUIElement("input", _objectSpread(_objectSpread({
            type: "checkbox"
          }, c.getAttribute("todoListChecked") ? {
            checked: "checked"
          } : null), a ? {
            disabled: "disabled"
          } : {
            tabindex: "-1"
          }));
          if (a) return u;
          var d = l.createContainerElement("span", {
            contenteditable: "false"
          }, u);
          return d.getFillerOffset = function () {
            return null;
          }, d;
        },
        canWrapElement: function canWrapElement(l) {
          return R(l, n.getListAttributeNames());
        },
        createWrapperElement: function createWrapperElement(l, c, _ref42) {
          var a = _ref42.dataPipeline;
          var u = ["todo-list__label"];
          return R(c, n.getListAttributeNames()) || u.push("todo-list__label_without-description"), l.createAttributeElement(a ? "label" : "span", {
            class: u.join(" ")
          });
        }
      }), n.on("checkElement", function (l, _ref43) {
        var c = _ref43.modelElement,
          a = _ref43.viewElement;
        var u = R(c, n.getListAttributeNames());
        a.hasClass("todo-list__label__description") != u && (l.return = !0, l.stop());
      }), n.on("checkElement", function (l, _ref44) {
        var c = _ref44.modelElement,
          a = _ref44.viewElement;
        var u = c.getAttribute("listType") == "todo" && k(c);
        var d = !1;
        var f = i.editing.view.createPositionBefore(a).getWalker({
          direction: "backward"
        });
        var _iterator55 = _createForOfIteratorHelper(f),
          _step55;
        try {
          for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
            var _ref45 = _step55.value;
            var m = _ref45.item;
            if (m.is("element") && i.editing.mapper.toModelElement(m)) break;
            m.is("element", "input") && m.getAttribute("type") == "checkbox" && (d = !0);
          }
        } catch (err) {
          _iterator55.e(err);
        } finally {
          _iterator55.f();
        }
        d != u && (l.return = !0, l.stop());
      }), n.on("postFixer", function (l, _ref46) {
        var c = _ref46.listNodes,
          a = _ref46.writer;
        var _iterator56 = _createForOfIteratorHelper(c),
          _step56;
        try {
          for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
            var _ref47 = _step56.value;
            var u = _ref47.node;
            var d = _ref47.previousNodeInList;
            if (!d || d.getAttribute("listItemId") != u.getAttribute("listItemId")) continue;
            var f = d.hasAttribute("todoListChecked"),
              m = u.hasAttribute("todoListChecked");
            m && !f ? (a.removeAttribute("todoListChecked", u), l.return = !0) : !m && f && (a.setAttribute("todoListChecked", !0, u), l.return = !0);
          }
        } catch (err) {
          _iterator56.e(err);
        } finally {
          _iterator56.f();
        }
      }), e.document.registerPostFixer(function (l) {
        var c = e.document.differ.getChanges();
        var a = !1;
        var _iterator57 = _createForOfIteratorHelper(c),
          _step57;
        try {
          for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
            var u = _step57.value;
            if (u.type == "attribute" && u.attributeKey == "listType") {
              var d = u.range.start.nodeAfter;
              u.attributeOldValue == "todo" && d.hasAttribute("todoListChecked") && (l.removeAttribute("todoListChecked", d), a = !0);
            } else if (u.type == "insert" && u.name != "$text") {
              var _iterator58 = _createForOfIteratorHelper(l.createRangeOn(u.position.nodeAfter)),
                _step58;
              try {
                for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
                  var _ref48 = _step58.value;
                  var _d5 = _ref48.item;
                  _d5.is("element") && _d5.getAttribute("listType") != "todo" && _d5.hasAttribute("todoListChecked") && (l.removeAttribute("todoListChecked", _d5), a = !0);
                }
              } catch (err) {
                _iterator58.e(err);
              } finally {
                _iterator58.f();
              }
            }
          }
        } catch (err) {
          _iterator57.e(err);
        } finally {
          _iterator57.f();
        }
        return a;
      }), this.listenTo(t.view.document, "keydown", function (l, c) {
        Ue(c) === Jt && (i.execute("checkTodoList"), l.stop());
      }, {
        priority: "high"
      }), this.listenTo(t.view.document, "todoCheckboxChange", function (l, c) {
        var a = c.target;
        if (!a || !a.is("element", "input")) return;
        var u = t.view.createPositionAfter(a),
          f = t.mapper.toModelPosition(u).parent;
        f && h(f) && f.getAttribute("listType") == "todo" && _this22._handleCheckmarkChange(f);
      }), this.listenTo(t.view.document, "arrowKey", si(e, i.locale), {
        context: "$text"
      }), this.listenTo(t.mapper, "viewToModelPosition", function (l, c) {
        var a = c.viewPosition.parent,
          u = a.is("attributeElement", "li") && c.viewPosition.offset == 0,
          d = ge(a) && c.viewPosition.offset <= 1,
          f = a.is("element", "span") && a.getAttribute("contenteditable") == "false" && ge(a.parent);
        if (!u && !d && !f) return;
        var m = c.modelPosition.nodeAfter;
        m && m.getAttribute("listType") == "todo" && (c.modelPosition = e.createPositionAt(m, 0));
      }, {
        priority: "low"
      }), this._initAriaAnnouncements();
    }
  }, {
    key: "_handleCheckmarkChange",
    value: function _handleCheckmarkChange(i) {
      var e = this.editor,
        t = e.model,
        n = Array.from(t.document.selection.getRanges());
      t.change(function (r) {
        r.setSelection(i, "end"), e.execute("checkTodoList"), r.setSelection(n);
      });
    }
  }, {
    key: "_initAriaAnnouncements",
    value: function _initAriaAnnouncements() {
      var _this$editor = this.editor,
        i = _this$editor.model,
        e = _this$editor.ui,
        t = _this$editor.t;
      var n = null;
      e && i.document.selection.on("change:range", function () {
        var r = i.document.selection.focus.parent,
          o = be(n),
          l = be(r);
        o && !l ? e.ariaLiveAnnouncer.announce(t("Leaving a to-do list")) : !o && l && e.ariaLiveAnnouncer.announce(t("Entering a to-do list")), n = r;
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "TodoListEditing";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }, {
    key: "requires",
    get: function get() {
      return [V];
    }
  }]);
}(w);
function Xt() {
  return function (s, i, e) {
    var t = e.writer,
      n = e.schema;
    if (!i.modelRange) return;
    var r = Array.from(i.modelRange.getItems({
      shallow: !0
    })).filter(function (o) {
      return o.getAttribute("listType") === "todo" && n.checkAttribute(o, "listItemId");
    }).reduce(function (o, l) {
      var c = l.getAttribute("listItemId");
      return o.has(c) || o.set(c, C(l)), o;
    }, new Map());
    var _iterator59 = _createForOfIteratorHelper(r.entries()),
      _step59;
    try {
      for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
        var _ref49 = _step59.value;
        var _ref50 = _slicedToArray(_ref49, 2);
        var o = _ref50[1];
        if (o.some(function (l) {
          return l.getAttribute("todoListChecked");
        })) {
          var _iterator60 = _createForOfIteratorHelper(o),
            _step60;
          try {
            for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
              var l = _step60.value;
              t.setAttribute("todoListChecked", !0, l);
            }
          } catch (err) {
            _iterator60.e(err);
          } finally {
            _iterator60.f();
          }
        }
      }
    } catch (err) {
      _iterator59.e(err);
    } finally {
      _iterator59.f();
    }
  };
}
function ei() {
  return function (s, i, e) {
    var t = i.modelCursor,
      n = t.parent,
      r = i.viewItem;
    if (!e.consumable.test(r, {
      name: !0
    }) || r.getAttribute("type") != "checkbox" || !t.isAtStart || !n.hasAttribute("listType")) return;
    e.consumable.consume(r, {
      name: !0
    });
    var o = e.writer;
    o.setAttribute("listType", "todo", n), i.viewItem.hasAttribute("checked") && o.setAttribute("todoListChecked", !0, n), i.modelRange = o.createRange(t);
  };
}
function j(s) {
  var i = new ye(s);
  return function (e, t, n) {
    var r = i.match(t.viewItem);
    r && n.consumable.consume(t.viewItem, r.match) && Object.assign(t, n.convertChildren(t.viewItem, t.modelCursor));
  };
}
function ti(s) {
  var i = new ye(s);
  return function (e, t, n) {
    var r = i.match(t.viewItem);
    if (!r) return;
    var o = r.match;
    o.name = !1, n.consumable.consume(t.viewItem, o);
  };
}
function R(s, i) {
  return (s.is("element", "paragraph") || s.is("element", "listItem")) && s.getAttribute("listType") == "todo" && k(s) && ii(s, i);
}
function ii(s, i) {
  var _iterator61 = _createForOfIteratorHelper(s.getAttributeKeys()),
    _step61;
  try {
    for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
      var _e6 = _step61.value;
      if (!_e6.startsWith("selection:") && !i.includes(_e6)) return !1;
    }
  } catch (err) {
    _iterator61.e(err);
  } finally {
    _iterator61.f();
  }
  return !0;
}
function si(s, i) {
  return function (e, t) {
    var n = Ke(t.keyCode, i.contentLanguageDirection),
      r = s.schema,
      o = s.document.selection;
    if (!o.isCollapsed) return;
    var l = o.getFirstPosition(),
      c = l.parent;
    if (n == "right" && l.isAtEnd) {
      var a = r.getNearestSelectionRange(s.createPositionAfter(c), "forward");
      if (!a) return;
      var u = a.start.parent;
      u && h(u) && u.getAttribute("listType") == "todo" && (s.change(function (d) {
        return d.setSelection(a);
      }), t.preventDefault(), t.stopPropagation(), e.stop());
    } else if (n == "left" && l.isAtStart && h(c) && c.getAttribute("listType") == "todo") {
      var _a4 = r.getNearestSelectionRange(s.createPositionBefore(c), "backward");
      if (!_a4) return;
      s.change(function (u) {
        return u.setSelection(_a4);
      }), t.preventDefault(), t.stopPropagation(), e.stop();
    }
  };
}
function ge(s) {
  return !!s && s.is("attributeElement") && s.hasClass("todo-list__label");
}
function be(s) {
  return !s || !s.is("element", "paragraph") && !s.is("element", "listItem") ? !1 : s.getAttribute("listType") == "todo";
}
var ni = /*#__PURE__*/function (_w0) {
  function ni() {
    _classCallCheck(this, ni);
    return _callSuper(this, ni, arguments);
  }
  _inherits(ni, _w0);
  return _createClass(ni, [{
    key: "init",
    value: function init() {
      var i = this.editor.t;
      z(this.editor, "todoList", i("To-do List"), mt);
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "TodoListUI";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(w);
var gi = /*#__PURE__*/function (_w1) {
  function gi() {
    _classCallCheck(this, gi);
    return _callSuper(this, gi, arguments);
  }
  _inherits(gi, _w1);
  return _createClass(gi, null, [{
    key: "requires",
    get: function get() {
      return [Qt, ni];
    }
  }, {
    key: "pluginName",
    get: function get() {
      return "TodoList";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(w);
export { pi as List, E as ListCommand, V as ListEditing, re as ListIndentCommand, hi as ListProperties, qt as ListPropertiesEditing, Yt as ListPropertiesUI, Wt as ListPropertiesUtils, Mt as ListUI, wt as ListUtils, gi as TodoList, Qt as TodoListEditing, ni as TodoListUI };